import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getRequest, patchRequest } from "../../axios";
import { useNavigate, useParams } from "react-router-dom";
import { authUserData } from "../../utils/Helper";
import {
  Checkbox,
  Collapse,
  Form,
  Input,
  Spin,
  Table,
  Breadcrumb,
  Row,
  Col,
  Space,
  Tooltip,
  Layout,
} from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { useTranslation } from "react-i18next";
import { SuccessNotificationMsg } from "../../utils/Notifications";
import AssignRFQVendor from "../PR/AssignRFQVendor";
import moment from "moment";

const ViewNewVendorBidRFQ = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const formRef = useRef();
  const VendorId = authUserData()?.vendor ? authUserData()?.vendor : null;
  const [apiLoading, setapiLoading] = useState(false);
  const [newState2, setNewState2] = useState([]);
  const [data, setData] = useState([]);
  const [CategoryId, setCtaegoryTree] = useState();
  const vendorBidId = id ? atob(id) : null;
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [companyName, setCompanyName] = useState([]);
  const [rfqnumber, setRFQNumber] = useState([]);
  const [AsFinalBidPrice, setIsFinalBidPrice] = useState("");
  const [rfqcurrency, setRFQCurrency] = useState([]);
  const [rfqfreight, setRFQFreight] = useState([]);
  const [rfqunloading, setRFQUnloading] = useState([]);
  const [rfqpricebasis, setRFQPriceBasis] = useState([]);
  const [rfqtransportInsurance, setRFQTransportInsurance] = useState([]);
  const [showUnitRateCementR1, setShowUnitRateCementR1] = useState(false);
  const [enableInputs, setEnableInputs] = useState(false);
  const [showUnitRateCementR, setShowUnitRateCementR] = useState(false);
  const [rfqopenorder, setRFQOpenOrder] = useState(false);
  const [rfqpricecap, setRFQPriceCap] = useState([]);
  const [showAdditionalCheckboxes, setShowAdditionalCheckboxes] =
    useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [buyingPattern, setBuyingPattern] = useState("");
  const [showUnitRateOfCement, setShowUnitRateOfCement] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [hideR0, setHideR0] = useState(false);
  const [hideR1, setHideR1] = useState(false);
  const [summaryTableData, setSummaryTableData] = useState([]);
  const [resetMode, setResetMode] = useState(false);
  const [revisedDate, setRevisedDate] = useState(false);
  const [finalDate, setFinalDate] = useState(false);
  const [isFinal, setIsFinal] = useState(false);
  const [showR0, setShowR0] = useState(false);
  const [rfqDetails, setRfqDetails] = useState([]);
  const [assignBuyer, setAssignBuyer] = useState([]);
  const [summaryTableData2, setSummaryTableData2] = useState([]);

  const [tableSummary, setTableSummary] = useState(tableData);

  const [summaryTableDataRevised, setSummaryTableDataRevised] = useState([]);
  const [summaryTableDataFinal, setSummaryTableDataFinal] = useState([]);

  const [winningArray, setWinningArray] = useState([]);
  const [lastFiveBid, setLastBid] = useState([]);
  const [showBidIcon, setShowBidIcon] = useState(false);

  const [bidRfqByVendor, setBidRfqByVendor] = useState(false);
  const [rfqAssignedOrNot, setRfqAssignedOrNot] = useState(null);
  const [isFinalBidPrice1, setIsFinalBidPrice1] = useState(false);

  const [initialBidDates, setInitialBidDates] = useState(null);
  const [revisedBidDates, setRevisedBidDates] = useState(null);
  const [finalBidDates, setFinalBidDates] = useState(null);
  const [categoryTreeName, setCategoryTreeName] = useState("");
  const handleHideR0Change = (e) => {
    setHideR0(e.target.checked);
  };
  const handleHideR1Change = (e) => {
    setHideR1(e.target.checked);
  };
  const { Panel } = Collapse;
  const { Content } = Layout;
  const currentDate = (() => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();

    return `${dd}-${mm}-${yyyy}`;
  })();

  useEffect(() => {
    const getVendorFive = async () => {
      try {
        const response = await getRequest(
          `bid-rfq/${rfqDetails.vendor_id}/last-five-bid-results/?company_id=${rfqDetails.company_id}`
        );

        if (response?.data?.success === true) {
          let last = response?.data?.data;
          let lastReverse = last?.reverse();
          setLastBid(lastReverse);
        }
      } catch (error) {
        console.error("Error fetching vendor winning ratio:", error);
      }
    };

    if (rfqDetails?.vendor_id && rfqDetails?.company_id) {
      getVendorFive();
    }
  }, [winningArray]);

  const [state, setState] = useState([]);
  const [rfqData, setRfqData] = useState({
    open_order: false,
    rfqamountcap: "",
    rfqtimelinecap: "",
    rfqopendeliverydate: "",
    rfqdeliverystartdate: "",
    rfqdeliveryenddate: "",
    rfqduedate: "",
    rfqpricecap: "",
  });

  const [showUnitRateOfFreight, setShowUnitRateOfFreight] = useState(false);

  const calculateUnitRateWithGst = (
    initialBidPriceUnitRate,
    quantity,
    gstRate
  ) => {
    return (
      initialBidPriceUnitRate * quantity * (gstRate / 100) +
      initialBidPriceUnitRate
    );
  };

  useEffect(() => {
    const getAssignBuyer = async () => {
      try {
        const response = await getRequest(`float-rfq/sales-manager-by-vendor/`);
        setAssignBuyer(response.data.results.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    getAssignBuyer();
  }, []);

  useEffect(() => {
    const getVendorWinningRatio = async () => {
      try {
        const response = await getRequest(
          `bid-rfq/${rfqDetails.vendor_id}/bid-rfq-winning-ratio-of-one-year/?company_id=${rfqDetails.company_id}`
        );

        if (response?.data?.success === true) {
          const arrayOfObjects = Object.entries(response.data.data).map(
            ([key, value]) => ({ key, value })
          );
          setWinningArray(arrayOfObjects);
        }
      } catch (error) {
        console.error("Error fetching vendor winning ratio:", error);
      }
    };

    if (rfqDetails?.vendor_id && rfqDetails?.company_id) {
      getVendorWinningRatio();
    }
  }, [rfqDetails]);

  const handleInputChange = (e, siteName, materialType, fieldName) => {
    if (resetMode) {
      setResetMode(false);
    }

    const { value } = e.target;
    const numericValue = parseFloat(value) || 0;

    setTableData((prevData) =>
      prevData.map((record) => {
        if (record.isSubtotal) {
          return record;
        }
        if (
          record.siteId === siteName &&
          record.material_type === materialType
        ) {
          if (
            [
              "final_bid_price_unit_rate",
              "revised_bid_price_unit_rate",
              "initial_bid_price_unit_rate",
            ].includes(fieldName)
          ) {
            return {
              ...record,
              [fieldName]: numericValue,
              unit_rate_with_gst: calculateUnitRateWithGst(
                numericValue,
                record.material_total_quantity,
                record.gst_rate
              ),
            };
          } else {
            return {
              ...record,
              [fieldName]: numericValue,
            };
          }
        }

        return record;
      })
    );
  };

  const handleInputChangeDate = (e, siteId, materialType, fieldName) => {
    if (resetMode) {
      setResetMode(false);
    }

    const { value } = e.target;

    setTableData((prevData) =>
      prevData.map((city) => ({
        ...city,
        bid_rfq_site_details: city.bid_rfq_site_details.map((site) => {
          if (site.site_id === siteId) {
            return {
              ...site,
              bid_rfq_material_details: site.bid_rfq_material_details.map(
                (material) => {
                  if (material.material_type === materialType) {
                    if (
                      [
                        "final_bid_price_unit_rate",
                        "revised_bid_price_unit_rate",
                        "initial_bid_price_date",
                      ].includes(fieldName)
                    ) {
                      const updatedMaterial = {
                        ...material,
                        [fieldName]: currentDate,
                        unit_rate_with_gst: calculateUnitRateWithGst(
                          currentDate,
                          material.material_total_quantity,
                          material.gst_rate
                        ),
                      };
                      return updatedMaterial;
                    } else {
                      const updatedMaterial = {
                        ...material,
                        [fieldName]: currentDate,
                      };
                      return updatedMaterial;
                    }
                  }
                  return material;
                }
              ),
            };
          }
          return site;
        }),
      }))
    );
  };

  const resetGSTValues = useCallback(() => {
    setTableData((prevData) =>
      prevData.map((item) => {
        if (item.material_type_name) {
          return {
            ...item,
            unit_rate_with_gst: 0,
          };
        }
        return item;
      })
    );
    setResetMode(true);

    setSummaryTableData((prevSummaryData) =>
      prevSummaryData.map((city) => ({
        ...city,
        sites: city.sites.map((site) => ({
          ...site,
          totalAmountWithGst: 0,
          totalAmountWithoutGst: 0,
        })),
      }))
    );
  }, [setTableData, setResetMode]);

  const handleInputChangeUnitRateWIthGST = (e, siteId, materialType) => {
    const { value } = e.target;

    setData((prevData) =>
      prevData.map((city) => ({
        ...city,
        bid_rfq_city_detail: city.bid_rfq_city_detail.map((site) =>
          site.site_id === siteId
            ? {
                ...site,
                material_details: site.material_details.map((material) =>
                  material.material_type === materialType
                    ? { ...material, unit_rate_with_gst: value }
                    : material
                ),
              }
            : site
        ),
      }))
    );
  };

  const handleInputChangeLQPForThisClient = (e, siteId, materialType) => {
    const { value } = e.target;

    setData((prevData) =>
      prevData.map((city) => ({
        ...city,
        bid_rfq_site_details: city.bid_rfq_site_details.map((site) =>
          site.site_id === siteId
            ? {
                ...site,
                bid_rfq_material_details: site.bid_rfq_material_details.map(
                  (material) =>
                    material.material_type === materialType
                      ? { ...material, lqp_for_this_client: value }
                      : material
                ),
              }
            : site
        ),
      }))
    );
  };

  const handleInputChangeAnyLqp = (e, siteId, materialType) => {
    const { value } = e.target;

    setData((prevData) =>
      prevData.map((city) => ({
        ...city,
        bid_rfq_site_details: city.bid_rfq_site_details.map((site) =>
          site.site_id === siteId
            ? {
                ...site,
                bid_rfq_material_details: site.bid_rfq_material_details.map(
                  (material) =>
                    material.material_type === materialType
                      ? { ...material, lqp_for_this_any_client: value }
                      : material
                ),
              }
            : site
        ),
      }))
    );
  };
  const handleDateChange = (cityIndex, siteIndex, field, value) => {
    const newData = [...tableData];
    newData[cityIndex].bid_rfq_site_details[siteIndex][field] = value;
    setTableData(newData);
  };
  useEffect(() => {
    const getVendorBidRFQ = async () => {
      setapiLoading(true);
      try {
        const response1 = await getRequest(
          `bid-rfq/${vendorBidId}/get-bid-rfq-city-wise/?vendor_id=${VendorId}`
        );
        const abc = response1.data.data;

        let cityTotals = {};
        let serialNumber = 0;
        let lastCityName = null;
        let lastSiteName = null;

        const fattenData = abc.bid_rfq_city_wise_detail.flatMap(
          (cityDetail) => {
            const siteMap = {};
            let cityTotal = {
              initial_bid_price_unit_rate: 0,
              initial_bid_price_unit_rate_of_freight: 0,
              material_total_quantity: 0,
              material_total_quantity_by_kg: 0,
              gst_rate: 0,
              unit_rate_with_gst: 0,

              unit_rate_with_gst_revised: 0,
              unit_rate_with_gst_final: 0,

              revised_bid_price_unit_rate: 0,
              revised_bid_price_unit_rate_of_freight: 0,
              final_bid_price_unit_rate: 0,
              final_bid_price_unit_rate_of_freight: 0,

              total_initial_bid_price_unit_rate: 0,
              total_revised_bid_price_unit_rate: 0,
              total_final_bid_price_unit_rate: 0,
            };

            cityDetail.bid_rfq_site_details.forEach((siteDetail) => {
              const siteId = siteDetail.site_id;

              if (!siteMap[siteId]) {
                siteMap[siteId] = {
                  ...siteDetail,
                  bid_rfq_material_details: [],
                  showSiteName: true,
                  subtotal: {
                    initial_bid_price_unit_rate: 0,
                    initial_bid_price_unit_rate_of_freight: 0,
                    material_total_quantity: 0,
                    material_total_quantity_by_kg: 0,
                    gst_rate: 0,
                    unit_rate_with_gst: 0,

                    unit_rate_with_gst_revised: 0,
                    unit_rate_with_gst_final: 0,

                    revised_bid_price_unit_rate: 0,
                    revised_bid_price_unit_rate_of_freight: 0,
                    final_bid_price_unit_rate: 0,
                    final_bid_price_unit_rate_of_freight: 0,

                    total_initial_bid_price_unit_rate: 0,
                    total_revised_bid_price_unit_rate: 0,
                    total_final_bid_price_unit_rate: 0,
                  },
                };
              }

              siteDetail.bid_rfq_material_details.forEach((materialDetail) => {
                const materialType = materialDetail.material_type;
                const existingMaterial = siteMap[
                  siteId
                ].bid_rfq_material_details.find(
                  (material) => material.material_type === materialType
                );

                if (existingMaterial) {
                  existingMaterial.material_total_quantity +=
                    materialDetail.material_total_quantity || 0;
                  existingMaterial.material_total_quantity_by_kg +=
                    materialDetail.material_total_quantity_by_kg || 0;
                  existingMaterial.gst_rate += materialDetail.gst_rate || 0;
                  existingMaterial.initial_bid_price_unit_rate +=
                    materialDetail.initial_bid_price_unit_rate || 0;
                  existingMaterial.initial_bid_price_unit_rate_of_freight +=
                    materialDetail.initial_bid_price_unit_rate_of_freight || 0;

                  existingMaterial.unit_rate_with_gst +=
                    materialDetail.unit_rate_with_gst || 0;

                  existingMaterial.unit_rate_with_gst +=
                    materialDetail.unit_rate_with_gst || 0;

                  existingMaterial.unit_rate_with_gst +=
                    materialDetail.unit_rate_with_gst || 0;

                  existingMaterial.revised_bid_price_unit_rate +=
                    materialDetail.revised_bid_price_unit_rate || 0;

                  existingMaterial.revised_bid_price_unit_rate_of_freight +=
                    materialDetail.revised_bid_price_unit_rate_of_freight || 0;
                  existingMaterial.final_bid_price_unit_rate +=
                    materialDetail.final_bid_price_unit_rate || 0;
                  existingMaterial.final_bid_price_unit_rate_of_freight +=
                    materialDetail.final_bid_price_unit_rate_of_freight || 0;
                } else {
                  siteMap[siteId].bid_rfq_material_details.push({
                    ...materialDetail,
                  });
                }
                siteMap[siteId].subtotal.initial_bid_price_unit_rate +=
                  materialDetail.initial_bid_price_unit_rate || 0;
                siteMap[
                  siteId
                ].subtotal.initial_bid_price_unit_rate_of_freight +=
                  materialDetail.initial_bid_price_unit_rate_of_freight || 0;
                siteMap[siteId].subtotal.material_total_quantity +=
                  materialDetail.material_total_quantity || 0;
                siteMap[siteId].subtotal.material_total_quantity_by_kg +=
                  materialDetail.material_total_quantity_by_kg || 0;

                siteMap[siteId].subtotal.gst_rate +=
                  materialDetail.gst_rate || 0;

                siteMap[siteId].subtotal.unit_rate_with_gst +=
                  materialDetail.unit_rate_with_gst || 0;

                siteMap[siteId].subtotal.unit_rate_with_gst_revised +=
                  materialDetail.revised_unit_rate_with_gst || 0;

                siteMap[siteId].subtotal.unit_rate_with_gst_final +=
                  materialDetail.final_unit_rate_with_gst || 0;

                siteMap[siteId].subtotal.revised_bid_price_unit_rate +=
                  materialDetail.revised_bid_price_unit_rate || 0;
                siteMap[
                  siteId
                ].subtotal.revised_bid_price_unit_rate_of_freight +=
                  materialDetail.revised_bid_price_unit_rate_of_freight || 0;
                siteMap[siteId].subtotal.final_bid_price_unit_rate +=
                  materialDetail.final_bid_price_unit_rate || 0;
                siteMap[siteId].subtotal.final_bid_price_unit_rate_of_freight +=
                  materialDetail.final_bid_price_unit_rate_of_freight || 0;

                siteMap[siteId].subtotal.total_initial_bid_price_unit_rate +=
                  materialDetail.initial_bid_amount_without_gst;

                siteMap[siteId].subtotal.total_revised_bid_price_unit_rate +=
                  materialDetail.revised_bid_amount_without_gst;

                siteMap[siteId].subtotal.total_final_bid_price_unit_rate +=
                  materialDetail.final_bid_amount_without_gst;

                cityTotal.initial_bid_price_unit_rate +=
                  materialDetail.initial_bid_price_unit_rate || 0;
                cityTotal.initial_bid_price_unit_rate_of_freight +=
                  materialDetail.initial_bid_price_unit_rate_of_freight || 0;
                cityTotal.material_total_quantity +=
                  materialDetail.material_total_quantity || 0;
                cityTotal.material_total_quantity_by_kg +=
                  materialDetail.material_total_quantity_by_kg || 0;
                cityTotal.gst_rate += materialDetail.gst_rate || 0;

                cityTotal.unit_rate_with_gst +=
                  materialDetail.unit_rate_with_gst || 0;

                cityTotal.unit_rate_with_gst_revised +=
                  materialDetail.revised_unit_rate_with_gst || 0;

                cityTotal.unit_rate_with_gst_final +=
                  materialDetail.final_unit_rate_with_gst || 0;

                cityTotal.revised_bid_price_unit_rate +=
                  materialDetail.revised_bid_price_unit_rate || 0;
                cityTotal.revised_bid_price_unit_rate_of_freight +=
                  materialDetail.revised_bid_price_unit_rate_of_freight || 0;
                cityTotal.final_bid_price_unit_rate +=
                  materialDetail.final_bid_price_unit_rate || 0;
                cityTotal.final_bid_price_unit_rate_of_freight +=
                  materialDetail.final_bid_price_unit_rate_of_freight || 0;

                cityTotal.total_initial_bid_price_unit_rate +=
                  materialDetail.initial_bid_price_unit_rate || 0;
                cityTotal.total_revised_bid_price_unit_rate +=
                  materialDetail.revised_bid_price_unit_rate || 0;
              });
            });

            const siteRows = Object.values(siteMap).flatMap((site) => {
              const materialRows = site.bid_rfq_material_details.map(
                (material) => {
                  const isCityChanged = lastCityName !== cityDetail.city_name;
                  const isSiteChanged = lastSiteName !== site.site_name;

                  if (isCityChanged) {
                    serialNumber++;
                    lastCityName = cityDetail.city_name;
                  }

                  if (isSiteChanged) {
                    lastSiteName = site.site_name;
                  }
                  if (material.revised_bid_price_date !== null) {
                    setRevisedDate(true);
                  } else {
                    setRevisedDate(false);
                  }

                  if (material.final_bid_price_date !== null) {
                    setFinalDate(true);
                  } else {
                    setFinalDate(false);
                  }
                  return {
                    sr_no: isCityChanged ? serialNumber : null,
                    city_name: isCityChanged
                      ? cityDetail.city_name || null
                      : null,
                    site_name: isSiteChanged ? site.site_name || null : null,
                    siteId: site.site_id,
                    material_type_name: material.material_type_name || "",
                    material_wise_uom: material.material_wise_uom || "",
                    material_type: material.material_type || null,
                    material_total_quantity:
                      material.material_total_quantity || 0,
                    material_total_quantity_by_kg:
                      material.material_total_quantity_by_kg || 0,
                    gst_rate: material.gst_rate || 0,
                    initial_bid_price_unit_rate:
                      material.initial_bid_price_unit_rate || 0,
                    initial_bid_price_unit_rate_of_freight:
                      material.initial_bid_price_unit_rate_of_freight || 0,
                    initial_bid_price_date:
                      material.initial_bid_price_date || "",
                    revised_bid_price_unit_rate:
                      material.revised_bid_price_unit_rate || 0,
                    revised_bid_price_unit_rate_of_freight:
                      material.revised_bid_price_unit_rate_of_freight || 0,
                    revised_bid_price_date:
                      material.revised_bid_price_date || "",
                    final_bid_price_unit_rate:
                      material.final_bid_price_unit_rate || 0,
                    final_bid_price_unit_rate_of_freight:
                      material.final_bid_price_unit_rate_of_freight || 0,
                    final_bid_price_date: material.final_bid_price_date || "",
                    unit_rate_with_gst: material.unit_rate_with_gst || 0,
                    unit_rate_with_gst_revised:
                      material.revised_unit_rate_with_gst || 0,
                    unit_rate_with_gst_final:
                      material.final_unit_rate_with_gst || 0,

                    initial_bid_price_amount:
                      material.initial_bid_price_unit_rate *
                        material.material_total_quantity +
                        material.initial_bid_price_unit_rate_of_freight *
                          material.material_total_quantity || 0,

                    revised_bid_price_amount:
                      material.revised_bid_price_unit_rate *
                        material.material_total_quantity +
                        material.revised_bid_price_unit_rate_of_freight *
                          material.material_total_quantity || 0,
                    final_bid_price_amount:
                      material.final_bid_price_unit_rate *
                        material.material_total_quantity +
                        material.final_bid_price_unit_rate_of_freight *
                          material.material_total_quantity || 0,
                          aggregate_conversion: response1?.data?.data?.aggregate_conversion,
                      sand_conversion: response1?.data?.data?.sand_conversion,
                      category_tree_name: response1?.data?.data?.category_tree_name
                  };
                }
              );

              // Add subtotal row
              const subtotalRow = {
                sr_no: null,
                city_name: null,
                site_name: "Subtotal",
                siteId: site.site_id,
                material_type_name: "",
                material_wise_uom: "",
                material_type: null,
                material_total_quantity: site.subtotal.material_total_quantity,
                material_total_quantity_by_kg:
                  site.subtotal.material_total_quantity_by_kg,
                gst_rate: site.subtotal.gst_rate,
                initial_bid_price_unit_rate:
                  site.subtotal.initial_bid_price_unit_rate,
                initial_bid_price_unit_rate_of_freight:
                  site.subtotal.initial_bid_price_unit_rate_of_freight,
                initial_bid_price_date: "",
                revised_bid_price_unit_rate:
                  site.subtotal.revised_bid_price_unit_rate,
                revised_bid_price_unit_rate_of_freight:
                  site.subtotal.revised_bid_price_unit_rate_of_freight,
                revised_bid_price_date: "",
                final_bid_price_unit_rate:
                  site.subtotal.final_bid_price_unit_rate,
                final_bid_price_unit_rate_of_freight:
                  site.subtotal.final_bid_price_unit_rate_of_freight,
                final_bid_price_date: "",
                // unit_rate_with_gst: site.subtotal.unit_rate_with_gst,
                // unit_rate_with_gst: 0,

                unit_rate_with_gst_final:
                  site.subtotal.unit_rate_with_gst_final,

                unit_rate_with_gst_revised:
                  site.subtotal.unit_rate_with_gst_revised,

                total_initial_bid_price_unit_rate:
                  site.subtotal.total_initial_bid_price_unit_rate || 0,

                total_initial_bid_price_unit_rate_of_freight:
                  site.subtotal.initial_bid_price_unit_rate_of_freight,

                total_revised_bid_price_unit_rate:
                  site.subtotal.total_revised_bid_price_unit_rate,

                total_final_bid_price_unit_rate:
                  site.subtotal.total_final_bid_price_unit_rate,

                total_revised_bid_price_unit_rate_of_freight:
                  site.subtotal.revised_bid_price_unit_rate_of_freight,
                total_unit_rate_with_gst: 0,
              };

              return [...materialRows, subtotalRow];
            });

            const totalInitialBidPrice = siteRows.reduce(
              (acc, row) => acc + (row.total_initial_bid_price_unit_rate || 0),
              0
            );

            const totalRevisedBidPrice = siteRows.reduce(
              (acc, row) => acc + (row.total_revised_bid_price_unit_rate || 0),
              0
            );

            const totalFinalBidPrice = siteRows.reduce(
              (acc, row) => acc + (row.total_final_bid_price_unit_rate || 0),
              0
            );

            const cityTotalRow = {
              sr_no: null,
              site_name: "City Total",
              siteId: null,
              material_type_name: "",
              material_wise_uom: "",
              material_type: null,
              material_total_quantity: cityTotal.material_total_quantity,
              material_total_quantity_by_kg:
                cityTotal.material_total_quantity_by_kg,
              gst_rate: cityTotal.gst_rate,
              initial_bid_price_unit_rate:
                cityTotal.initial_bid_price_unit_rate,
              initial_bid_price_unit_rate_of_freight:
                cityTotal.initial_bid_price_unit_rate_of_freight,
              initial_bid_price_date: "",
              revised_bid_price_unit_rate:
                cityTotal.revised_bid_price_unit_rate,
              revised_bid_price_unit_rate_of_freight:
                cityTotal.revised_bid_price_unit_rate_of_freight,
              revised_bid_price_date: "",
              final_bid_price_unit_rate: cityTotal.final_bid_price_unit_rate,
              final_bid_price_unit_rate_of_freight:
                cityTotal.final_bid_price_unit_rate_of_freight,
              final_bid_price_date: "",
              unit_rate_with_gst: cityTotal.unit_rate_with_gst,

              unit_rate_with_gst_revised: cityTotal.unit_rate_with_gst_revised,

              unit_rate_with_gst_final: cityTotal.unit_rate_with_gst_final,

              total_initial_bid_price_unit_rate: totalInitialBidPrice,

              total_revised_bid_price_unit_rate: totalRevisedBidPrice,

              total_final_bid_price_unit_rate: totalFinalBidPrice,
            };

            return [...siteRows, cityTotalRow];
          }
        );

        setTableData(fattenData);
        setCategoryTreeName(response1?.data?.data?.category_tree_name)
        const newFat = fattenData;

        setTableSummary(newFat);

        if (abc?.bid_rfq_city_wise_detail) {
          let initialDates = null;
          let revisedDates = null;
          let finalDates = null;

          const firstCity = abc.bid_rfq_city_wise_detail[0];
          if (firstCity) {
            const firstSite = firstCity.bid_rfq_site_details[0];
            if (firstSite) {
              const firstMaterial = firstSite.bid_rfq_material_details[0];
              if (firstMaterial) {
                initialDates = firstMaterial.initial_bid_price_date || null;
                revisedDates = firstMaterial.revised_bid_price_date || null;
                finalDates = firstMaterial.final_bid_price_date || null;
              }
            }
          }

          setInitialBidDates(initialDates);
          setRevisedBidDates(revisedDates);
          setFinalBidDates(finalDates);
        }

        setRfqDetails(abc);
        let bidCity = abc.bid_rfq_city_wise_detail[0];

        let bidSite = bidCity.bid_rfq_site_details[0];

        let bidMaterial = bidSite.bid_rfq_material_details[0];

        if (bidMaterial.bid_rfq_id !== null) {
          setShowR0(true);
        } else {
          setShowR0(false);
        }

        const isFinalBidPrice = abc.is_final_bid_price;
        setCompanyName(abc.company);
        setIsFinalBidPrice(abc.is_final_bid_price);
        setRFQNumber(abc.rfq_number);
        setRFQCurrency(abc.currency_name);
        setRFQPriceBasis(abc.price_basis);
        setRFQFreight(abc.freight);
        setRFQUnloading(abc.unloading);
        setRFQTransportInsurance(abc.transport_insurance);
        setRFQOpenOrder(abc.open_order);
        setRFQPriceCap(abc.price_cap);

        setRfqData({
          open_order: abc.open_order,
          rfqamountcap: abc.amount_cap,
          rfqtimelinecap: abc.timeline_cap,
          rfqopendeliverydate: abc.delivery_date,
          rfqdeliverystartdate: abc.delivery_start_date,
          rfqdeliveryenddate: abc.delivery_end_date,
          rfqduedate: abc.rfq_due_date,
          rfqpricecap: abc.price_cap,
        });
        setState((prevState) => {
          return {
            ...prevState,
            bid_rfq_city_wise_detail: abc.bid_rfq_city_wise_detail,
          };
        });

        const AsFinalBidPrice = abc.is_final_bid_price;

        const r1FinalPrice =
          abc.bid_rfq_city_wise_detail[0].bid_rfq_site_details[0]
            .bid_rfq_material_details[0].revised_bid_price_unit_rate > 0;

        const rFinalPrice =
          abc.bid_rfq_city_wise_detail[0].bid_rfq_site_details[0]
            .bid_rfq_material_details[0].final_bid_price_unit_rate;
        setIsFinalBidPrice1(abc.is_final_bid_price);
        setRfqAssignedOrNot(abc.rfq_assign_sales_manager.id);
        setBidRfqByVendor(abc.final_bid_data);

        const shouldShowBidIcon =
          abc.is_final_bid_price === false &&
          abc.rfq_vendor_assign_sales_manager !== null &&
          abc.bid_rfq_by_vendor === false;
        setShowBidIcon(shouldShowBidIcon);

        if (r1FinalPrice && AsFinalBidPrice) {
          setShowUnitRateOfCement(true);
          setHideR1(true);
          setShowUnitRateCementR1(false);
          setShowUnitRateCementR(false);
        } else if (rFinalPrice && AsFinalBidPrice) {
          setShowUnitRateOfCement(true);
          setShowUnitRateCementR1(true);
          setShowUnitRateCementR(true);
        } else if (AsFinalBidPrice === "true") {
          setShowUnitRateOfCement(true);
          setShowUnitRateCementR1(false);
          setShowUnitRateCementR(false);
        } else {
          setShowUnitRateOfCement(true);
          setShowUnitRateCementR1(true);
          setShowUnitRateCementR(true);
        }

        setIsFinalBidPrice(AsFinalBidPrice);
        const buying_pattern = abc.bid_buying_pattern;
        setBuyingPattern(buying_pattern);
        if (buying_pattern === "Unit Rate of Cement excluding Freight") {
          setShowUnitRateOfCement(true);
          setShowUnitRateOfFreight(true);
        } else if (buying_pattern === "Unit Rate of Cement including Freight") {
          setShowUnitRateOfCement(true);
          setShowUnitRateOfFreight(false);
        } else if (buying_pattern === "Total Unit Rate") {
          setShowUnitRateOfCement(false);
          setShowUnitRateOfFreight(true);
        }
      } catch (error) {
        console.error("Error:", error);
        setapiLoading(false);
      } finally {
        setapiLoading(false);
      }
    };
    getVendorBidRFQ();
  }, [vendorBidId]);
  const [siteWithoutGstRates, setSiteWithoutGstRates] = useState({});
  const hideR1Columns = hideR1 ? [] : {};

  const calculateSubtotals = (tableData) => {
    let siteSubtotals = {};
    let grandTotalCement = 0;
    let grandTotalFreight = 0;

    tableData.forEach((record) => {
      if (!record.isSubtotal) {
        const siteId = record.siteId;
        if (!siteSubtotals[siteId]) {
          siteSubtotals[siteId] = {
            totalCement: 0,
            totalFreight: 0,
          };
        }
        siteSubtotals[siteId].totalCement += Number(
          record.initial_bid_price_unit_rate || 0
        );
        siteSubtotals[siteId].totalFreight += Number(
          record.initial_bid_price_unit_rate_of_freight || 0
        );
        grandTotalCement += Number(record.initial_bid_price_unit_rate || 0);
        grandTotalFreight += Number(
          record.initial_bid_price_unit_rate_of_freight || 0
        );
      }
    });

    return { grandTotalCement, grandTotalFreight, siteSubtotals };
  };

  const isRfqDueDateValid = () => {
    const dueDate = moment(rfqDetails.rfq_due_date, "DD-MM-YYYY HH:mm");
    return dueDate.isValid() && dueDate.isAfter(moment());
  };

  const { grandTotalCement, grandTotalFreight, siteSubtotals } =
    calculateSubtotals(tableData);

  // Parse and check if due date-time is passed
  const dueDateStr = rfqDetails.rfq_due_date; // "23-05-25 09:00"
  let disableAssign = false;

  if (dueDateStr) {
    const [datePart, timePart] = dueDateStr.split(" ");
    const [yy, mm, dd] = datePart.split("-").map(Number);
    const [hh, min] = timePart.split(":").map(Number);

    const fullYear = 2000 + yy; // Convert 23 → 2023
    const dueDate = new Date(fullYear, mm - 1, dd, hh, min);

    disableAssign = dueDate < new Date();
  }

  const columns = [
    {
      title: "Sr.",
      dataIndex: "sr_no",
      key: "sr_no",
      width: 50,
      fixed: "left",
    },
    {
      title: "City",
      dataIndex: "city_name",
      key: "city_name",
      width: 120,
      fixed: "left",
    },
    {
      title: "Site",
      dataIndex: "site_name",
      key: "site_name",
      fixed: "left",
      width: 120,

      render: (text, record) => {
        if (record?.site_name === "Subtotal") {
          return <div className="subtotal1">{"Sub total"}</div>;
        } else if (record?.site_name === "City Total") {
          return <div className="citytotal2">{"City total"}</div>;
        } else {
          return <div className="normal-field">{record.site_name}</div>;
        }
      },
    },
    {
      title: "Material Type",
      dataIndex: "material_type_name",
      key: "material_type_name",
      fixed: "left",
      width: 200,
    },

    {
      title: "Qty.",
      dataIndex: "material_total_quantity",
      key: "material_total_quantity",
      align: "right",
      width: 90,
      fixed: "left",
      render: (text, record) => {
        if (record?.site_name === "Subtotal") {
          return null;
        } else if (record?.site_name === "City Total") {
          return null;
        } else {
          return (
            <div className="normal-field">
              {record.material_total_quantity?.toLocaleString("en-IN", {
                maximumFractionDigits: 0,
              })}
            </div>
          );
        }
      },
    },
    {
      title: "UoM.",
      dataIndex: "material_wise_uom",
      key: "material_wise_uom",
      width: 90,
      fixed: "left",

      render: (text, record) => {
        if (record?.material_wise_uom === "Cubic Meter") {
          return <div className="normal-field">Cu. Mtr.</div>;
        } else {
          return (
            <div className="normal-field">{record?.material_wise_uom}</div>
          );
        }
      },
    },
    finalDate && {
      title: (
        <>
          <Tooltip color="#094E8F" placement="top" title={"R - Final BID"}>
            <span>R (Without GST)</span> {`(${finalBidDates})`}
          </Tooltip>
        </>
      ),
      children: [
        (buyingPattern === "Unit Rate of Cement including Freight" ||
          buyingPattern === "Unit Rate of Cement excluding Freight") &&
          showUnitRateOfCement && {
            title: "Unit Rate",
            dataIndex: "final_bid_price_unit_rate",
            key: "final_bid_price_unit_rate",
            align: "right",
            width: "130px",
            render: (text, record) => {
              const isSubtotal = record.isSubtotal;
              let grandTotal = 0;
              grandTotal += record.final_bid_price_unit_rate;
              if (record?.site_name === "Subtotal") {
                return <div> </div>;
              } else if (record?.site_name === "City Total") {
                return <div> </div>;
              } else {
                return (
                  <div className="normal-field">
                    {/* ₹{" "} */}
                    {finalBidDates && record.final_bid_price_unit_rate === 0
                      ? "Not Quoted"
                      : record.final_bid_price_unit_rate?.toLocaleString(
                          "en-IN",
                          {
                            maximumFractionDigits: 0,
                          }
                        ) ?? ""}
                  </div>
                );
              }
            },
          },
        buyingPattern === "Unit Rate of Cement excluding Freight" &&
          showUnitRateOfFreight && {
            title: "Unit Rate Of Freight",
            dataIndex: "final_bid_price_unit_rate_of_freight",
            key: "final_bid_price_unit_rate_of_freight",
            align: "right",
            width: "130px",
            render: (text, record) => {
              const isSubtotal = record.isSubtotal;
              let grandTotal = 0;
              grandTotal += record.final_bid_price_unit_rate_of_freight;

              if (record?.site_name === "Subtotal") {
                return (
                  <div>
                    {/* {" "}
                  {`₹ ${record.final_bid_price_unit_rate_of_freight.toLocaleString(
                    "en-IN"
                  )}`} */}
                  </div>
                );
              } else if (record?.site_name === "City Total") {
                return (
                  <div>
                    {/* {`₹ ${record.final_bid_price_unit_rate_of_freight.toLocaleString(
                  "en-IN"
                )}`} */}
                  </div>
                );
              } else {
                return (
                  <div className="normal-field">
                    {`${
                      finalBidDates &&
                      record.final_bid_price_unit_rate_of_freight === 0
                        ? "Not Quoted"
                        : record.final_bid_price_unit_rate_of_freight.toLocaleString(
                            "en-IN"
                          )
                    }`}
                  </div>
                );
              }
            },
          },
        showUnitRateOfCement && {
          title: "Amount",
          dataIndex: "final_bid_price_amount",
          key: "final_bid_price_amount",
          width: "130px",
          align: "right",
          render: (text, record) => {
            const isSubtotal = record.isSubtotal;

            const allRecords = tableData;

            const sameMaterialTypeRecords = allRecords.filter(
              (item) => item.material_type === record.material_type
            );

            const isValueConsistent = sameMaterialTypeRecords.every(
              (item) =>
                item.initial_bid_price_unit_rate ===
                record.initial_bid_price_unit_rate
            );
            const isFirstEntry = (record) => {
              const sameMaterialTypeRecords = tableData.filter(
                (item) => item.material_type === record.material_type
              );
              return sameMaterialTypeRecords.indexOf(record) === 0;
            };
            return record?.site_name === "Subtotal" ? (
              <div className="subtotal1" style={{ marginLeft: "1px" }}>
                ₹{" "}
                {record.total_final_bid_price_unit_rate?.toLocaleString(
                  "en-IN"
                ) ?? "0"}
              </div>
            ) : record?.site_name === "City Total" ? (
              <div className="citytotal2" style={{ marginLeft: "1px" }}>
                ₹{" "}
                {record.total_final_bid_price_unit_rate?.toLocaleString(
                  "en-IN",
                  { maximumFractionDigits: 0 }
                ) ?? "0"}
              </div>
            ) : record?.site_name !== "Subtotal" ? (
              <div className="normal-field" style={{ marginLeft: "1px" }}>
                {finalBidDates && record.final_bid_price_amount === 0
                  ? "Not Quoted"
                  : record.final_bid_price_amount?.toLocaleString("en-IN") ??
                    ""}
              </div>
            ) : (
              <div className="normal-field" style={{ marginLeft: "1px" }}>
                ₹ {record.final_bid_price_amount?.toLocaleString("en-IN") ?? ""}
              </div>
            );
            //}
          },
        },
        showUnitRateOfCement && {
          title: "Unit Rate With GST",
          dataIndex: "unit_rate_with_gst_final",
          key: "unit_rate_with_gst_final",
          width: "130px",
          align: "right",
          render: (text, record) => {
            const isSubtotal = record.isSubtotal;
            let grandTotal = 0;
            if (!isSubtotal) {
              grandTotal = tableData
                .filter(
                  (row) => row.siteId === record.siteId && !row.isSubtotal
                )
                .reduce(
                  (acc, curr) =>
                    acc + (parseFloat(curr.unit_rate_with_gst_revised) || 0),
                  0
                );
            }
            return (
              <>
                {record?.site_name === "City Total" ||
                record?.site_name === "Subtotal" ? (
                  ""
                ) : (
                  <div className="normal-field" style={{ marginLeft: "1px" }}>
                    {finalBidDates && record.unit_rate_with_gst_final === 0
                      ? "Not Quoted"
                      : record.unit_rate_with_gst_final?.toFixed(2) ?? 0}
                  </div>
                )}
              </>
            );
          },
        },
      ].filter(Boolean),
    },

    !hideR1 &&
      revisedDate && {
        title: (
          <>
            <Tooltip color="#094E8F" placement="top" title={"R1 - Revised BID"}>
              <span>R1 (Without GST)</span>{" "}
              {!hideR1 && revisedDate ? `(${revisedBidDates})` : ""}
            </Tooltip>
          </>
        ),
        children: [
          (buyingPattern === "Unit Rate of Cement including Freight" ||
            buyingPattern === "Unit Rate of Cement excluding Freight") &&
            showUnitRateOfCement && {
              title: "Unit Rate",
              dataIndex: "revised_bid_price_unit_rate",
              key: "revised_bid_price_unit_rate",
              align: "right",
              width: "130px",
              render: (text, record) => {
                const isSubtotal = record.isSubtotal;
                let grandTotal = 0;
                grandTotal += record.revised_bid_price_unit_rate;

                if (record?.site_name === "Subtotal") {
                  return <div> </div>;
                } else if (record?.site_name === "City Total") {
                  return <div> </div>;
                } else {
                  return (
                    <div className="normal-field">
                      {revisedBidDates &&
                      record.revised_bid_price_unit_rate === 0
                        ? "Not Quoted"
                        : `₹ ${record.revised_bid_price_unit_rate?.toLocaleString(
                            "en-IN",
                            { maximumFractionDigits: 0 }
                          )}` ?? ""}
                    </div>
                  );
                }
              },
            },

          buyingPattern === "Unit Rate of Cement excluding Freight" &&
            showUnitRateOfFreight && {
              title: "Unit Rate Of Freight",
              dataIndex: "revised_bid_price_unit_rate_of_freight",
              key: "revised_bid_price_unit_rate_of_freight",
              align: "right",
              width: "130px",
              render: (text, record) => {
                const isSubtotal = record.isSubtotal;
                let grandTotal = 0;
                grandTotal += record.revised_bid_price_unit_rate_of_freight;
                if (record?.site_name === "Subtotal") {
                  return (
                    <div>
                      {/* ₹{" "}
                  {record.revised_bid_price_unit_rate_of_freight?.toLocaleString(
                    "en-IN",
                    { maximumFractionDigits: 0 }
                  ) ?? ""} */}
                    </div>
                  );
                } else if (record?.site_name === "City Total") {
                  return (
                    <div>
                      {/* ₹{" "}
                  {record.revised_bid_price_unit_rate_of_freight?.toLocaleString(
                    "en-IN",
                    { maximumFractionDigits: 0 }
                  ) ?? ""} */}
                    </div>
                  );
                } else {
                  return (
                    <div className="normal-field">
                      {revisedBidDates &&
                      record.revised_bid_price_unit_rate_of_freight === 0
                        ? "Not Quoted"
                        : record.revised_bid_price_unit_rate_of_freight?.toLocaleString(
                            "en-IN",
                            { maximumFractionDigits: 0 }
                          ) ?? ""}
                    </div>
                  );
                }
              },
            },
          showUnitRateOfCement && {
            title: "Amount",
            dataIndex: "revised_bid_price_amount",
            key: "revised_bid_price_amount",
            width: "130px",
            align: "right",
            render: (text, record) => {
              const isSubtotal = record.isSubtotal;

              const allRecords = tableData;

              const sameMaterialTypeRecords = allRecords.filter(
                (item) => item.material_type === record.material_type
              );

              const isValueConsistent = sameMaterialTypeRecords.every(
                (item) =>
                  item.initial_bid_price_unit_rate ===
                  record.initial_bid_price_unit_rate
              );
              const isFirstEntry = (record) => {
                const sameMaterialTypeRecords = tableData.filter(
                  (item) => item.material_type === record.material_type
                );
                return sameMaterialTypeRecords.indexOf(record) === 0;
              };

              return record?.site_name === "Subtotal" ? (
                <div className="subtotal1" style={{ marginLeft: "1px" }}>
                  ₹{" "}
                  {record.total_revised_bid_price_unit_rate?.toLocaleString(
                    "en-IN"
                  ) ?? "0"}
                </div>
              ) : record?.site_name === "City Total" ? (
                <div className="citytotal2" style={{ marginLeft: "1px" }}>
                  ₹{" "}
                  {record.total_revised_bid_price_unit_rate?.toLocaleString(
                    "en-IN",
                    { maximumFractionDigits: 0 }
                  ) ?? "0"}
                </div>
              ) : record?.site_name !== "Subtotal" ? (
                <div className="normal-field" style={{ marginLeft: "1px" }}>
                  {revisedBidDates && record.revised_bid_price_amount === 0
                    ? "Not Quoted"
                    : `₹ ${record.revised_bid_price_amount?.toLocaleString(
                        "en-IN",
                        { maximumFractionDigits: 0 }
                      )}` ?? ""}
                </div>
              ) : (
                <div className="normal-field" style={{ marginLeft: "1px" }}>
                  ₹{" "}
                  {record.total_revised_bid_price_unit_rate?.toLocaleString(
                    "en-IN",
                    { maximumFractionDigits: 0 }
                  ) ?? ""}
                </div>
              );
              //}
            },
          },
          showUnitRateOfCement && {
            title: "Unit Rate With GST",
            dataIndex: "unit_rate_with_gst_revised",
            key: "unit_rate_with_gst_revised",
            width: "130px",
            render: (text, record) => {
              const isSubtotal = record.isSubtotal;
              let grandTotal = 0;
              if (!isSubtotal) {
                grandTotal = tableData
                  .filter(
                    (row) => row.siteId === record.siteId && !row.isSubtotal
                  )
                  .reduce(
                    (acc, curr) =>
                      acc + (parseFloat(curr.unit_rate_with_gst_revised) || 0),
                    0
                  );
              }
              return (
                <>
                  {record?.site_name === "City Total" ||
                  record?.site_name === "Subtotal" ? (
                    ""
                  ) : (
                    <div className="normal-field" style={{ marginLeft: "1px" }}>
                      {revisedBidDates &&
                      record.unit_rate_with_gst_revised === 0
                        ? "Not Quoted"
                        : record.unit_rate_with_gst_revised?.toFixed(2) ?? 0}
                    </div>
                  )}
                </>
              );
            },
          },
        ].filter(Boolean),
      },
    showR0 &&
      !hideR0 && {
        title: (
          <>
            <Tooltip color="#094E8F" placement="top" title={"R0 - Initial BID"}>
              <span>R0 (Without GST)</span>{" "}
              {!hideR1 && revisedDate ? `(${initialBidDates})` : ""}
            </Tooltip>
          </>
        ),
        children: [
          (buyingPattern === "Unit Rate of Cement including Freight" ||
            buyingPattern === "Unit Rate of Cement excluding Freight") &&
            showUnitRateOfCement && {
              title: "Unit Rate",
              dataIndex: "initial_bid_price_unit_rate",
              key: "initial_bid_price_unit_rate",
              align: "right",
              width: "130px",
              render: (text, record) => {
                const isSubtotal = record.isSubtotal;
                if (record?.site_name === "Subtotal") {
                  return <div> </div>;
                } else if (record?.site_name === "City Total") {
                  return <div> </div>;
                } else {
                  return (
                    <div className="normal-field">
                      {initialBidDates &&
                      record.initial_bid_price_unit_rate === 0
                        ? "Not Quoted"
                        : `₹ ${record.initial_bid_price_unit_rate?.toLocaleString(
                            "en-IN",
                            { maximumFractionDigits: 0 }
                          )}` ?? ""}
                    </div>
                  );
                }
              },
            },

          buyingPattern === "Unit Rate of Cement excluding Freight" &&
            showUnitRateOfFreight && {
              title: "Unit Rate Of Freight",
              dataIndex: "initial_bid_price_unit_rate_of_freight",
              key: "initial_bid_price_unit_rate_of_freight",
              align: "right",
              width: "130px",
              render: (text, record) => {
                const isSubtotal = record.isSubtotal;
                if (record?.site_name === "Subtotal") {
                  return (
                    <div>
                      {/* ₹{" "}
                  {record.initial_bid_price_unit_rate_of_freight?.toLocaleString(
                    "en-IN",
                    { maximumFractionDigits: 0 }
                  ) ?? ""} */}
                    </div>
                  );
                } else if (record?.site_name === "City Total") {
                  return (
                    <div>
                      {/* ₹{" "}
                  {record.initial_bid_price_unit_rate_of_freight?.toLocaleString(
                    "en-IN",
                    { maximumFractionDigits: 0 }
                  ) ?? ""} */}
                    </div>
                  );
                } else {
                  return (
                    <div className="normal-field">
                      {initialBidDates &&
                      record.initial_bid_price_unit_rate_of_freight === 0
                        ? "Not Quoted"
                        : `₹ ${record.initial_bid_price_unit_rate_of_freight?.toLocaleString(
                            "en-IN",
                            { maximumFractionDigits: 0 }
                          )}` ?? ""}
                    </div>
                  );
                }
              },
            },

          showUnitRateOfCement && {
            title: "Amount",
            dataIndex: "initial_bid_price_amount",
            key: "initial_bid_price_amount",
            width: "130px",
            align: "right",
            render: (text, record) => {
              const isSubtotal = record.isSubtotal;

              const allRecords = tableData;

              const sameMaterialTypeRecords = allRecords.filter(
                (item) => item.material_type === record.material_type
              );

              const isValueConsistent = sameMaterialTypeRecords.every(
                (item) =>
                  item.initial_bid_price_unit_rate ===
                  record.initial_bid_price_unit_rate
              );
              const isFirstEntry = (record) => {
                const sameMaterialTypeRecords = tableData.filter(
                  (item) => item.material_type === record.material_type
                );
                return sameMaterialTypeRecords.indexOf(record) === 0;
              };
              return record?.site_name === "Subtotal" ? (
                <div className="subtotal1" style={{ marginLeft: "1px" }}>
                  ₹{" "}
                  {record.total_initial_bid_price_unit_rate?.toLocaleString(
                    "en-IN"
                  ) ?? "0"}
                </div>
              ) : record?.site_name === "City Total" ? (
                <div className="citytotal2" style={{ marginLeft: "1px" }}>
                  ₹{" "}
                  {record.total_initial_bid_price_unit_rate?.toLocaleString(
                    "en-IN",
                    { maximumFractionDigits: 0 }
                  ) ?? "0"}
                </div>
              ) : record?.site_name !== "Subtotal" ? (
                <div className="normal-field" style={{ marginLeft: "1px" }}>
                  {initialBidDates && record.initial_bid_price_amount === 0
                    ? "Not Quoted"
                    : `₹ ${record.initial_bid_price_amount?.toLocaleString(
                        "en-IN",
                        {
                          maximumFractionDigits: 0,
                        }
                      )}` ??
                      "0" ??
                      ""}
                </div>
              ) : (
                <div className="normal-field" style={{ marginLeft: "1px" }}>
                  ₹{" "}
                  {record.total_initial_bid_price_unit_rate?.toLocaleString(
                    "en-IN",
                    { maximumFractionDigits: 0 }
                  ) ??
                    "0" ??
                    ""}
                </div>
              );
            },
          },
          showUnitRateOfCement && {
            title: "Unit Rate With GST",
            dataIndex: "unit_rate_with_gst",
            key: "unit_rate_with_gst",
            width: "130px",
            render: (text, record) => {
              const isSubtotal = record.isSubtotal;
              let grandTotal = 0;
              if (!isSubtotal) {
                grandTotal = tableData
                  .filter(
                    (row) => row.siteId === record.siteId && !row.isSubtotal
                  )
                  .reduce(
                    (acc, curr) =>
                      acc + (parseFloat(curr.unit_rate_with_gst) || 0),
                    0
                  );
              }
              return (
                <>
                  {record?.site_name === "City Total" ||
                  record?.site_name === "Subtotal" ? (
                    ""
                  ) : (
                    <div className="normal-field" style={{ marginLeft: "1px" }}>
                      {initialBidDates && record.unit_rate_with_gst === 0
                        ? "Not Quoted"
                        : `₹ ${record.unit_rate_with_gst?.toFixed(2)}` ?? 0}
                    </div>
                  )}
                </>
              );
            },
          },
        ].filter(Boolean),
      },
  ].filter(Boolean);

  const columns2 = [
    {
      title: "City Name",
      dataIndex: "city_name",
      key: "city_name",
      render: (text, record) => <span>{record.city_name}</span>,
    },
    {
      title: "Site Name",
      dataIndex: "site_name",
      key: "site_name",
      render: (text, record) => (
        <div>
          {record.bid_rfq_site_details.map((site) => (
            <Input
              disabled
              key={site.site_id}
              value={site.site_name}
              className="InputItem"
            />
          ))}
        </div>
      ),
    },
    {
      title: "Amount With GST",
      dataIndex: "amount_with_gst",
      key: "amount_with_gst",
      render: (text, record) => (
        <div>
          {record.bid_rfq_site_details.map((site) => (
            <div key={site?.site_id}></div>
          ))}
          <div>
            {(() => {
              const bidMaterial = record.bid_rfq_site_details;
              const materialDetails = bidMaterial.flatMap(
                (site) => site.bid_rfq_material_details
              );

              const sum = materialDetails.reduce((acc, material) => {
                return acc + (parseFloat(material.amount_with_gst) || 0);
              }, 0);

              return (
                <Input disabled value={sum.toFixed(0)} className="InputItem" />
              );
            })()}
          </div>
        </div>
      ),
    },
    {
      title: "Amount Without GST",
      dataIndex: "amount_without_gst",
      key: "amount_without_gst",
      render: (text, record) => (
        <div>
          {record.bid_rfq_site_details.map((site) => (
            <div key={site?.site_id}></div>
          ))}
          <div>
            {(() => {
              const bidMaterial = record.bid_rfq_site_details;
              const materialDetails = bidMaterial.flatMap(
                (site) => site.bid_rfq_material_details
              );

              const sum = materialDetails.reduce((acc, material) => {
                return acc + (parseFloat(material.amount_without_gst) || 0);
              }, 0);

              return (
                <Input disabled value={sum.toFixed(0)} className="InputItem" />
              );
            })()}
          </div>
        </div>
      ),
    },
  ];

  const columns3 = [
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      fixed: "left",
      width: 100,
    },
    {
      title: "Site",
      dataIndex: "sites",
      key: "site",
      fixed: "left",
      width: 100,

      render: (sites, record) => {
        if (record.site === "Total") {
          return <div className="total3">Total</div>;
        }
        return (
          <div>
            {Array.isArray(sites) && sites.length > 0
              ? sites[0].site
              : "No site data"}
          </div>
        );
      },
    },
    finalDate && {
      title: "R",
      children: [
        {
          title: "Amount Without GST",
          dataIndex: "sites",
          key: "amountWithoutGstR",
          width: 150,
          align: "right",
          render: (sites, record) => {
            if (record.site === "Total") {
              return (
                <div className="total3">
                  {`₹ 
                  ${record.totalAmountWithoutGstR?.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}`}
                </div>
              );
            } else {
              const percentage = sites[0]?.percentageWithoutGstR || 0;
              return (
                <div>
                  {`₹ 
                  ${
                    Array.isArray(sites) && sites.length > 0
                      ? sites[0].totalAmountWithoutGstR?.toLocaleString(
                          "en-IN",
                          {
                            maximumFractionDigits: 0,
                          }
                        )
                      : "0.00"
                  }${" "}
                  (${percentage}%)`}
                </div>
              );
            }
          },
        },
        {
          title: "Amount With GST",
          dataIndex: "sites",
          key: "amountWithGstR",
          width: 150,
          align: "right",
          render: (sites, record) => {
            if (record.site === "Total") {
              return (
                <div className="total3">
                  {`₹ 
                  ${record.totalAmountWithGstR?.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}`}
                </div>
              );
            } else {
              const percentage = sites[0]?.percentageWithGstR || 0;
              return (
                <div>
                  {`₹ 
                  ${
                    Array.isArray(sites) && sites.length > 0
                      ? sites[0].totalAmountWithGstR?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        })
                      : "0.00"
                  }${" "}
                  (${percentage}%)`}
                </div>
              );
            }
          },
        },
      ],
    },

    !hideR1 &&
      revisedDate && {
        title: "R1",
        children: [
          {
            title: "Amount Without GST",
            dataIndex: "sites",
            key: "amountWithoutGstR1",
            width: 150,
            align: "right",
            render: (sites, record) => {
              if (record.site === "Total") {
                return (
                  <div className="total3">
                    {`₹ 
                  ${record.totalAmountWithoutGstR1?.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}`}
                  </div>
                );
              } else {
                const percentage = sites[0]?.percentageWithoutGstR1 || 0;
                return (
                  <div>
                    {`₹ 
                  ${
                    Array.isArray(sites) && sites.length > 0
                      ? sites[0].totalAmountWithoutGstR1?.toLocaleString(
                          "en-IN",
                          { maximumFractionDigits: 0 }
                        )
                      : "0.00"
                  }
                  ${""}(${percentage}%)`}
                  </div>
                );
              }
            },
          },
          {
            title: "Amount With GST",
            dataIndex: "sites",
            key: "amountWithGstR1",
            width: 150,
            align: "right",
            render: (sites, record) => {
              if (record.site === "Total") {
                return (
                  <div className="total3">
                    {`₹ 
                  ${record.totalAmountWithGstR1?.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}`}
                  </div>
                );
              } else {
                const percentage = sites[0]?.percentageWithGstR1 || 0;
                return (
                  <div>
                    {`₹ 
                  ${
                    Array.isArray(sites) && sites.length > 0
                      ? sites[0].totalAmountWithGstR1?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        })
                      : "0.00"
                  }
                  ${""}(${percentage}%)`}
                  </div>
                );
              }
            },
          },
        ],
      },
    !hideR0 &&
      showR0 && {
        title: "R0",

        children: [
          {
            title: "Amount Without GST",
            dataIndex: "sites",
            key: "amountWithoutGstR0",
            align: "right",
            // width: 200,
            width: 150,

            render: (sites, record) => {
              if (record.site === "Total") {
                return (
                  <div className="total3">
                    {`₹ 
                  ${record.totalAmountWithoutGstR0?.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}`}
                  </div>
                );
              } else {
                const percentage = sites[0]?.percentageWithoutGst || 0;
                return (
                  <div>
                    {`₹ 
                  ${
                    Array.isArray(sites) && sites.length > 0
                      ? sites[0].totalAmountWithoutGstR0?.toLocaleString(
                          "en-IN",
                          { maximumFractionDigits: 0 }
                        )
                      : "0.00"
                  }${" "}
                  (${percentage}%)`}
                  </div>
                );
              }
            },
          },
          {
            title: "Amount With GST",
            dataIndex: "sites",
            key: "amountWithGstR0",
            align: "right",
            // width: 200,
            width: 150,

            render: (sites, record) => {
              if (record.site === "Total") {
                return (
                  <div className="total3">
                    {`₹ 
                  ${record.totalAmountWithGstR0?.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}`}
                  </div>
                );
              } else {
                const percentage = sites[0]?.percentageWithGst || 0;

                return (
                  <div>
                    {`₹ 
                  ${
                    Array.isArray(sites) && sites.length > 0
                      ? sites[0].totalAmountWithGstR0?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        })
                      : "0.00"
                  }${" "}
                  (${percentage}%)`}
                  </div>
                );
              }
            },
          },
        ],
      },
  ].filter(Boolean);

  useEffect(() => {
    const transformedData = [];

    // Filter out "City Total" rows
    const filteredTableData = tableData.filter(
      (item) => item.site_name !== "City Total"
    );
    const cityMap = new Map();

    let totalQuantity = 0;
    let totalWithGstR0 = 0;
    let totalWithoutGstR0 = 0;
    let totalWithGstR1 = 0;
    let totalWithoutGstR1 = 0;
    let totalWithGstR = 0;
    let totalWithoutGstR = 0;

    // Sum for all sites (to be used in percentage calculation)
    let grandTotalWithoutGstR0 = 0;
    let grandTotalWithGstR0 = 0;

    let grandTotalWithoutGstR1 = 0;
    let grandTotalWithGstR1 = 0;

    let grandTotalWithoutGstR = 0;
    let grandTotalWithGstR = 0;

    filteredTableData.forEach((item) => {
      if (item.site_name === "Subtotal") {
        const cityKey = item.siteId;
        const cityData = cityMap.get(cityKey);

        if (cityData) {
          const subtotalData = {
            site: "Subtotal",
            totalAmountWithGstR0: cityData.sites.reduce(
              (sum, site) => sum + site.totalAmountWithGstR0,
              0
            ),
            totalAmountWithoutGstR0: cityData.sites.reduce(
              (sum, site) => sum + site.totalAmountWithoutGstR0,
              0
            ),
            totalAmountWithGstR1: cityData.sites.reduce(
              (sum, site) => sum + site.totalAmountWithGstR1,
              0
            ),
            totalAmountWithoutGstR1: cityData.sites.reduce(
              (sum, site) => sum + site.totalAmountWithoutGstR1,
              0
            ),
            totalAmountWithGstR: cityData.sites.reduce(
              (sum, site) => sum + site.totalAmountWithGstR,
              0
            ),
            totalAmountWithoutGstR: cityData.sites.reduce(
              (sum, site) => sum + site.totalAmountWithoutGstR,
              0
            ),
          };
          cityData.sites.push(subtotalData);
        }
      } else if (item.site_name) {
        const siteData = {
          site_id: item.siteId,
          site: item.site_name,
          totalAmountWithGstR0: 0,
          totalAmountWithoutGstR0: 0,
          totalAmountWithGstR1: 0,
          totalAmountWithoutGstR1: 0,
          totalAmountWithGstR: 0,
          totalAmountWithoutGstR: 0,
          percentageWithoutGst: 0, // Percentage field
          percentageWithGst: 0,
          percentageWithoutGstR1: 0, // Percentage field
          percentageWithGstR1: 0,
          percentageWithoutGstR: 0, // Percentage field
          percentageWithGstR: 0,
        };

        const materialData = filteredTableData.filter(
          (data) => data.siteId === item.siteId && data.site_name !== "Subtotal"
        );

        // Calculate Amount With and Without GST for initial (R0)
        siteData.totalAmountWithGstR0 = materialData.reduce((sum, material) => {
          const unitRate =
            (parseFloat(material.initial_bid_price_unit_rate) || 0) +
            (parseFloat(material.initial_bid_price_unit_rate_of_freight) || 0);
          const totalAmountWithoutGst =
            // unitRate * (material.material_total_quantity_by_kg || 0);
            unitRate * (material.material_total_quantity || 0);
          const gstAmount =
            totalAmountWithoutGst * ((material.gst_rate || 0) / 100);
          return sum + totalAmountWithoutGst + gstAmount;
        }, 0);

        siteData.totalAmountWithoutGstR0 = materialData.reduce(
          (sum, material) => {
            const unitRate =
              (parseFloat(material.initial_bid_price_unit_rate) || 0) +
              (parseFloat(material.initial_bid_price_unit_rate_of_freight) ||
                0);
            return (
              // sum + unitRate * (material.material_total_quantity_by_kg || 0)
              sum + unitRate * (material.material_total_quantity || 0)
            );
          },
          0
        );

        // Repeat the above logic for revised (R1) and final (R) bids
        siteData.totalAmountWithGstR1 = materialData.reduce((sum, material) => {
          const unitRate =
            (parseFloat(material.revised_bid_price_unit_rate) || 0) +
            (parseFloat(material.revised_bid_price_unit_rate_of_freight) || 0);
          const totalAmountWithoutGst =
            // unitRate * (material.material_total_quantity_by_kg || 0);
            unitRate * (material.material_total_quantity || 0);
          const gstAmount =
            totalAmountWithoutGst * ((material.gst_rate || 0) / 100);
          return sum + totalAmountWithoutGst + gstAmount;
        }, 0);

        siteData.totalAmountWithoutGstR1 = materialData.reduce(
          (sum, material) => {
            const unitRate =
              (parseFloat(material.revised_bid_price_unit_rate) || 0) +
              (parseFloat(material.revised_bid_price_unit_rate_of_freight) ||
                0);
            return (
              // sum + unitRate * (material.material_total_quantity_by_kg || 0)
              sum + unitRate * (material.material_total_quantity || 0)
            );
          },
          0
        );

        // Final Bid Calculation (R)
        siteData.totalAmountWithGstR = materialData.reduce((sum, material) => {
          const unitRate =
            (parseFloat(material.final_bid_price_unit_rate) || 0) +
            (parseFloat(material.final_bid_price_unit_rate_of_freight) || 0);
          const totalAmountWithoutGst =
            // unitRate * (material.material_total_quantity_by_kg || 0);
            unitRate * (material.material_total_quantity || 0);
          const gstAmount =
            totalAmountWithoutGst * ((material.gst_rate || 0) / 100);
          return sum + totalAmountWithoutGst + gstAmount;
        }, 0);

        siteData.totalAmountWithoutGstR = materialData.reduce(
          (sum, material) => {
            const unitRate =
              (parseFloat(material.final_bid_price_unit_rate) || 0) +
              (parseFloat(material.final_bid_price_unit_rate_of_freight) || 0);
            return (
              // sum + unitRate * (material.material_total_quantity_by_kg || 0)
              sum + unitRate * (material.material_total_quantity || 0)
            );
          },
          0
        );

        grandTotalWithoutGstR0 += siteData.totalAmountWithoutGstR0 || 0;
        grandTotalWithGstR0 += siteData.totalAmountWithGstR0 || 0;

        grandTotalWithoutGstR1 += siteData.totalAmountWithoutGstR1 || 0;
        grandTotalWithGstR1 += siteData.totalAmountWithGstR1 || 0;

        grandTotalWithoutGstR += siteData.totalAmountWithoutGstR || 0;
        grandTotalWithGstR += siteData.totalAmountWithGstR || 0;

        // Accumulate totals
        totalQuantity += item.material_total_quantity || 0;
        totalWithGstR0 += siteData.totalAmountWithGstR0;
        totalWithoutGstR0 += siteData.totalAmountWithoutGstR0;
        totalWithGstR1 += siteData.totalAmountWithGstR1;
        totalWithoutGstR1 += siteData.totalAmountWithoutGstR1;
        totalWithGstR += siteData.totalAmountWithGstR;
        totalWithoutGstR += siteData.totalAmountWithoutGstR;

        const cityKey = item.siteId;
        if (!cityMap.has(cityKey)) {
          cityMap.set(cityKey, { city: item.city_name, sites: [] });
        }

        const cityData = cityMap.get(cityKey);
        if (!cityData.sites.some((site) => site.site === siteData.site)) {
          cityData.sites.push(siteData);
        }
      }
    });

    Array.from(cityMap.values()).forEach((cityData) => {
      cityData.sites.forEach((siteData) => {
        // Percentage Calculation
        siteData.percentageWithoutGst = grandTotalWithoutGstR0
          ? (
              (siteData.totalAmountWithoutGstR0 / grandTotalWithoutGstR0) *
              100
            ).toFixed(2)
          : 0;

        siteData.percentageWithGst = grandTotalWithGstR0
          ? (
              (siteData.totalAmountWithGstR0 / grandTotalWithGstR0) *
              100
            ).toFixed(2)
          : 0;

        siteData.percentageWithoutGstR1 = grandTotalWithoutGstR1
          ? (
              (siteData.totalAmountWithoutGstR1 / grandTotalWithoutGstR1) *
              100
            ).toFixed(2)
          : 0;

        siteData.percentageWithGstR1 = grandTotalWithGstR1
          ? (
              (siteData.totalAmountWithGstR1 / grandTotalWithGstR1) *
              100
            ).toFixed(2)
          : 0;

        siteData.percentageWithoutGstR = grandTotalWithoutGstR
          ? (
              (siteData.totalAmountWithoutGstR / grandTotalWithoutGstR) *
              100
            ).toFixed(2)
          : 0;

        siteData.percentageWithGstR = grandTotalWithGstR
          ? ((siteData.totalAmountWithGstR / grandTotalWithGstR) * 100).toFixed(
              2
            )
          : 0;
      });
    });

    // Create total row
    const totalRow = {
      site: "Total",
      totalAmountWithGstR0: totalWithGstR0,
      totalAmountWithoutGstR0: totalWithoutGstR0,
      totalAmountWithGstR1: totalWithGstR1,
      totalAmountWithoutGstR1: totalWithoutGstR1,
      totalAmountWithGstR: totalWithGstR,
      totalAmountWithoutGstR: totalWithoutGstR,
      material_total_quantity: totalQuantity,
    };

    const finalData = Array.from(cityMap.values());
    finalData.push(totalRow);

    setSummaryTableData(finalData);
  }, [tableData, resetMode, setSummaryTableData]);

useEffect(() => {
  const materialTotals = {};
  let sandConversion = null;
  let aggregateConversion = null;
  let isSand = false;
  let isAggregate = false;
  tableSummary.forEach((cityDetail) => {

    sandConversion = cityDetail?.sand_conversion;
    aggregateConversion = cityDetail?.aggregate_conversion; 
    isSand = cityDetail?.category_tree_name?.includes("Sand") ? true : false
    isAggregate = cityDetail?.category_tree_name?.includes("Aggregate") ? true : false
    const key = cityDetail.material_wise_uom !== "Cubic Meter" && cityDetail.material_type_name;

    if (!key) return;

    if (!materialTotals[key]) {
      materialTotals[key] = {
        material_type_name: cityDetail.material_type_name,
        total_weighted_price: 0, 
        total_quantity_MT: 0,    
        total_quantity_meter: 0,
        category_tree_name: cityDetail.category_tree_name,
      };
    }

    const baseRate =
      (cityDetail.revised_bid_price_unit_rate || 0) +
      (cityDetail.revised_bid_price_unit_rate_of_freight || 0);

       if (cityDetail.material_wise_uom === "meter") {
        materialTotals[key].total_quantity_meter +=
          cityDetail.material_total_quantity;

        materialTotals[key].total_weighted_price +=
          baseRate * cityDetail.material_total_quantity;

        return; 
      }

    let quantityMT = 0;
    let rateMT = 0;

    if (cityDetail.material_wise_uom === "MT") {
      quantityMT = cityDetail.material_total_quantity;
    } else if (cityDetail.material_wise_uom === "Cubic Meter") {
      quantityMT = cityDetail.material_total_quantity * 1.6;
    } else if (cityDetail.material_wise_uom === "Bag") {
      quantityMT = cityDetail.material_total_quantity * 0.05; 
    } else if (cityDetail.material_wise_uom === "Cum." && cityDetail.category_tree_name.includes('Sand')) {
      quantityMT = cityDetail.material_total_quantity * cityDetail.sand_conversion; 
    } else if (cityDetail.material_wise_uom === "Cum." && cityDetail.category_tree_name.includes('Aggregate')) {
      quantityMT = cityDetail.material_total_quantity * cityDetail.aggregate_conversion; 
    } 



    if (cityDetail.material_wise_uom === "MT") {
      rateMT = baseRate; 
    } else if (cityDetail.material_wise_uom === "Cubic Meter") {
      rateMT = baseRate / 1.6; 
    } else if (cityDetail.material_wise_uom === "Bag") {
      rateMT = baseRate / 0.05; 
    }  else if (cityDetail.material_wise_uom === "Cum." && cityDetail.category_tree_name.includes('Sand')) {
      rateMT = baseRate / cityDetail.sand_conversion; 
    } else if (cityDetail.material_wise_uom === "Cum." && cityDetail.category_tree_name.includes('Aggregate')) {
      rateMT = baseRate / cityDetail.aggregate_conversion; 
    }
    const weightedPrice = rateMT * quantityMT;

    materialTotals[key].total_weighted_price += weightedPrice;
    materialTotals[key].total_quantity_MT += quantityMT;
    materialTotals[key].category_tree_name = cityDetail.category_tree_name;
  });

const fattenData = Object.values(materialTotals).map((material) => {
  const { total_weighted_price, total_quantity_MT, total_quantity_meter, category_tree_name } = material;

      if (category_tree_name.includes("Earthing")) {
        const averagePriceMeter = total_quantity_meter
          ? total_weighted_price / total_quantity_meter
          : 0;

         const isCopper = material.material_type_name
          ?.toUpperCase()
          .includes("CU");

        const isGI = material.material_type_name?.toUpperCase().includes("GI");

        const sizeMatch =
          material.material_type_name.match(/(\d+)\s*x\s*(\d+)/i);

        const width = sizeMatch ? Number(sizeMatch[1]) : 0;
        const thickness = sizeMatch ? Number(sizeMatch[2]) : 0;

        let density = 0;
        if (isCopper) density = 8960;
        else if (isGI) density = 7850;

        const kgPerMeter =
          width && thickness && density
            ? (width * thickness * density) / 1_000_000
            : 0;

        const averagePriceKG =
          averagePriceMeter && kgPerMeter ? averagePriceMeter / kgPerMeter : 0;
            
        return {
          ...material,
          averagePriceMeter,
          averagePriceKG,
        };
      }

  const averagePriceMT = total_quantity_MT
    ? total_weighted_price / total_quantity_MT
    : 0;

  let averagePriceCum = 0;
  if (category_tree_name.includes("Sand")) {
    averagePriceCum = averagePriceMT * (1 / (sandConversion || 1.6));
  } else if (category_tree_name.includes("Aggregate")) {
    averagePriceCum = averagePriceMT * (1 / (aggregateConversion || 1.45));
  } else {
    averagePriceCum = averagePriceMT * (1 / 1.6);
  }

  const averagePriceKG = averagePriceMT / 1000;
  const averagePriceBag = averagePriceMT * 0.05;

  return {
    ...material,
    averagePriceMT,
    averagePriceCum,
    averagePriceKG : averagePriceMT / 1000,
    averagePriceBag : averagePriceMT * 0.05,
  };
});
  
  setSummaryTableDataRevised(fattenData);
}, [tableSummary]);

useEffect(() => {
  const materialTotals = {};
  let sandConversion = null;
  let aggregateConversion = null;
  let isSand = false;
  let isAggregate = false;
  tableSummary.forEach((cityDetail) => {
    const key =
      cityDetail.material_wise_uom !== "Cubic Meter" &&
      cityDetail.material_type_name;
     sandConversion = cityDetail?.sand_conversion;
    aggregateConversion = cityDetail?.aggregate_conversion; 
    isSand = cityDetail?.category_tree_name?.includes("Sand") ? true : false
    isAggregate = cityDetail?.category_tree_name?.includes("Aggregate") ? true : false
    if (!key) return;

    if (!materialTotals[key]) {
      materialTotals[key] = {
        material_type_name: cityDetail.material_type_name,
        total_weighted_price: 0, 
        total_quantity_MT: 0,    
        total_quantity_meter: 0,
        category_tree_name: cityDetail.category_tree_name 
      };
    }

    const baseRate =
      (cityDetail.final_bid_price_unit_rate || 0) +
      (cityDetail.final_bid_price_unit_rate_of_freight || 0);

            if (cityDetail.material_wise_uom === "meter") {
        materialTotals[key].total_quantity_meter +=
          cityDetail.material_total_quantity;

        materialTotals[key].total_weighted_price +=
          baseRate * cityDetail.material_total_quantity;

        return; 
      }


    let quantityMT = 0;
    let rateMT = 0;
    

    if (cityDetail.material_wise_uom === "MT") {
      quantityMT = cityDetail.material_total_quantity;
    } else if (cityDetail.material_wise_uom === "Cubic Meter") {
      quantityMT = cityDetail.material_total_quantity * 1.6;
    } else if (cityDetail.material_wise_uom === "Bag") {
      quantityMT = cityDetail.material_total_quantity * 0.05; 
    }  else if (cityDetail.material_wise_uom === "Cum." && cityDetail.category_tree_name.includes('Sand')) {
      quantityMT = cityDetail.material_total_quantity * cityDetail.sand_conversion; 
    } else if (cityDetail.material_wise_uom === "Cum." && cityDetail.category_tree_name.includes('Aggregate')) {
      quantityMT = cityDetail.material_total_quantity * cityDetail.aggregate_conversion; 
    } 


    if (cityDetail.material_wise_uom === "MT") {
      rateMT = baseRate; // already per MT
    } else if (cityDetail.category_tree_name.includes('Sand') &&cityDetail.material_wise_uom === "Cum.") {
      rateMT = baseRate / cityDetail.sand_conversion; 
    } else if (cityDetail.category_tree_name.includes('Aggregate') && cityDetail.material_wise_uom === "Cum.") {
      rateMT = baseRate / cityDetail.aggregate_conversion; 
    } else if (cityDetail.material_wise_uom === "Cubic Meter" || cityDetail.material_wise_uom === "Cum.") {
      rateMT = baseRate / 1.6; // per Cum → per MT
    } else if (cityDetail.material_wise_uom === "Bag") {
      rateMT = baseRate / 0.05; // per Bag → per MT
    } 

    const weightedPrice = rateMT * quantityMT;

    materialTotals[key].total_weighted_price += weightedPrice;
    materialTotals[key].total_quantity_MT += quantityMT;
    materialTotals[key].category_tree_name = cityDetail.category_tree_name;
  });

  const fattenData = Object.values(materialTotals).map((material) => {
    const { total_weighted_price, total_quantity_MT, total_quantity_meter,category_tree_name } = material;

          if (category_tree_name.includes("Earthing")) {
        const averagePriceMeter = total_quantity_meter
          ? total_weighted_price / total_quantity_meter
          : 0;

        const isCopper = material.material_type_name
          ?.toUpperCase()
          .includes("CU");

        const isGI = material.material_type_name?.toUpperCase().includes("GI");

        const sizeMatch =
          material.material_type_name.match(/(\d+)\s*x\s*(\d+)/i);

        const width = sizeMatch ? Number(sizeMatch[1]) : 0;
        const thickness = sizeMatch ? Number(sizeMatch[2]) : 0;

        let density = 0;
        if (isCopper) density = 8960;
        else if (isGI) density = 7850;

        const kgPerMeter =
          width && thickness && density
            ? (width * thickness * density) / 1_000_000
            : 0;

        const averagePriceKG =
          averagePriceMeter && kgPerMeter ? averagePriceMeter / kgPerMeter : 0;
            
        return {
          ...material,
          averagePriceMeter,
          averagePriceKG,
          kgPerMeter
        };
      } 

const averagePriceMT = total_quantity_MT
    ? total_weighted_price / total_quantity_MT
    : 0;

  let averagePriceCum = 0;
  if (category_tree_name?.includes("Sand")) {
    averagePriceCum = averagePriceMT * (1 / (sandConversion || 1.6));
  } else if (category_tree_name?.includes("Aggregate")) {
    averagePriceCum = averagePriceMT * (1 / (aggregateConversion || 1.45));
  } else {
    averagePriceCum = averagePriceMT * (1 / 1.6);
  }

  const averagePriceKG = averagePriceMT / 1000;
  const averagePriceBag = averagePriceMT * 0.05;

    return {
      ...material,
      averagePriceMT,
      averagePriceCum,
      averagePriceKG: averagePriceMT / 1000,
      averagePriceBag: averagePriceMT * 0.05,
    };
  });

  setSummaryTableDataFinal(fattenData);
}, [tableSummary]);

  useEffect(() => {
    const materialTotals = {};
    let sandConversion = null;
    let aggregateConversion = null;
    let isSand = false;
    let isAggregate = false;

    tableSummary.forEach((cityDetail) => {
      const key = cityDetail.material_wise_uom !== "Cubic Meter" && cityDetail.material_type_name;
      if (!key) return;

      if (!materialTotals[key]) {
        materialTotals[key] = {
          material_type_name: cityDetail.material_type_name,
          total_weighted_price: 0,
          total_quantity_MT: 0,
          total_quantity_meter: 0,
          category_tree_name: cityDetail.category_tree_name 
        };
      }

    const baseRate =
      (cityDetail.initial_bid_price_unit_rate || 0) +
      (cityDetail.initial_bid_price_unit_rate_of_freight || 0);

            if (cityDetail.material_wise_uom === "meter") {
        materialTotals[key].total_quantity_meter +=
          cityDetail.material_total_quantity;

        materialTotals[key].total_weighted_price +=
          baseRate * cityDetail.material_total_quantity;

        return; // 🚨 DO NOT fall into MT logic
      }

    let quantityMT = 0;
    let rateMT = 0;

    if (cityDetail.material_wise_uom === "MT") {
      quantityMT = cityDetail.material_total_quantity;
    } else if (cityDetail.material_wise_uom === "Cubic Meter") {
      quantityMT = cityDetail.material_total_quantity * 1.6; 
    } else if (cityDetail.material_wise_uom === "Bag") {
      quantityMT = cityDetail.material_total_quantity * 0.05;
    } else if (cityDetail.material_wise_uom === "Cum." && cityDetail.category_tree_name?.includes('Sand')) {
      quantityMT = cityDetail.material_total_quantity * cityDetail.sand_conversion; 
    } else if (cityDetail.material_wise_uom === "Cum." && cityDetail.category_tree_name?.includes('Aggregate')) {
      quantityMT = cityDetail.material_total_quantity * cityDetail.aggregate_conversion; 
    } 



    if (cityDetail.material_wise_uom === "MT") {
      rateMT = baseRate; 
    } else if (cityDetail.material_wise_uom === "Cubic Meter") {
      rateMT = baseRate / 1.6;
    } else if (cityDetail.material_wise_uom === "Bag") {
      rateMT = baseRate / 0.05; 
    } else if (cityDetail.material_wise_uom === "Cum." && cityDetail.category_tree_name?.includes('Sand')) {
      rateMT = baseRate / cityDetail.sand_conversion; 
    } else if (cityDetail.material_wise_uom === "Cum." && cityDetail.category_tree_name?.includes('Aggregate')) {
      rateMT = baseRate / cityDetail.aggregate_conversion; 
    }
      const weightedPrice = rateMT * quantityMT;

      materialTotals[key].total_weighted_price += weightedPrice;
      materialTotals[key].total_quantity_MT += quantityMT;
      materialTotals[key].category_tree_name = cityDetail.category_tree_name;
    });

const fattenData = Object.values(materialTotals).map((material) => {
  const { total_weighted_price, total_quantity_MT, total_quantity_meter, category_tree_name } = material;
  
  
    if (category_tree_name?.includes("Earthing")) {
        const averagePriceMeter = total_quantity_meter
          ? total_weighted_price / total_quantity_meter
          : 0;

        const isCopper = material.material_type_name
          ?.toUpperCase()
          .includes("CU");

        const isGI = material.material_type_name?.toUpperCase().includes("GI");

        const sizeMatch =
          material.material_type_name.match(/(\d+)\s*x\s*(\d+)/i);

        const width = sizeMatch ? Number(sizeMatch[1]) : 0;
        const thickness = sizeMatch ? Number(sizeMatch[2]) : 0;

        let density = 0;
        if (isCopper) density = 8960;
        else if (isGI) density = 7850;

        const kgPerMeter =
          width && thickness && density
            ? (width * thickness * density) / 1_000_000
            : 0;

        const averagePriceKG =
          averagePriceMeter && kgPerMeter ? averagePriceMeter / kgPerMeter : 0;

        return {
          ...material,
          averagePriceMeter,
          averagePriceKG,
          kgPerMeter,
        };
      }

  const averagePriceMT = total_quantity_MT
    ? total_weighted_price / total_quantity_MT
    : 0;

  let averagePriceCum = 0;
  if (category_tree_name?.includes("Sand")) {
    averagePriceCum = averagePriceMT * (1 / (sandConversion || 1.6));
  } else if (category_tree_name?.includes("Aggregate")) {
    averagePriceCum = averagePriceMT * (1 / (aggregateConversion || 1.45));
  } else {
    averagePriceCum = averagePriceMT * (1 / 1.6);
  }

  const averagePriceKG = averagePriceMT / 1000;
  const averagePriceBag = averagePriceMT * 0.05;

  return {
    ...material,
    averagePriceMT,
    averagePriceCum,
    averagePriceKG: averagePriceMT / 1000,
    averagePriceBag: averagePriceMT * 0.05,
  };
});

    setSummaryTableData2(fattenData);
  }, [tableSummary]);

  const columns4 = [
    {
      title: "R0 - Initial BID (without GST)",
      children: [
        {
          title: "Material Type",
          dataIndex: "material_type_name",
          key: "material_type_name",
          width: 130,
          render: (text, record) => {
            if (record.uom !== "Cubic Meter") {
              return <span>{text}</span>;
            }
          },
        },
        ...(!categoryTreeName.includes("Earthing")
          ? [
            {
          title: "Average Price/MT",
          dataIndex: "averagePriceMT",
          key: "averagePriceMT",
          align: "right",
          render: (averagePriceMT) => {
            if (initialBidDates && isNaN(averagePriceMT)) {
              return "Not Quoted";
            } else {
              return averagePriceMT
                ? `₹ ${averagePriceMT.toFixed(2)} / MT`
                : `₹ 0`;
            }
          },
        },
        {
                title: "Average Price/Bag",
                dataIndex: "averagePriceBag",
                key: "averagePriceBag",
                align: "right",
                render: (averagePriceBag) => {
                  if (initialBidDates && isNaN(averagePriceBag)) {
                    return "Not Quoted";
                  } else {
                    return averagePriceBag
                      ? `₹ ${averagePriceBag.toFixed(2)} / Bag`
                      : `₹ 0`;
                  }
                },
              }
            ]
              : []),
        ...(categoryTreeName.includes("Sand")  || categoryTreeName.includes("Aggregate") &&
        !categoryTreeName.includes("Earthing")
          ? [
              {
                title: "Average Price/Cum.",
                dataIndex: "averagePriceCum",
                key: "averagePriceCum",
                align: "right",
                render: (averagePriceCum) => {
                  if (initialBidDates && isNaN(averagePriceCum)) {
                    return "Not Quoted";
                  } else {
                    return averagePriceCum
                      ? `₹ ${averagePriceCum.toFixed(2)} / Cum`
                      : `₹ 0`;
                  }
                },
              },
            ]
          : []),
           ...(categoryTreeName.includes("Earthing")
          ? [
              {
                title: "Average Price/Meter",
                dataIndex: "averagePriceMeter",
                key: "averagePriceMeter",
                align: "right",
                render: (value) =>
                  initialBidDates && isNaN(value)
                    ? "Not Quoted"
                    : `₹ ${(value || 0).toFixed(2)} / Meter`,
              },
            ]
          : []),
        ...(categoryTreeName.includes("Sand") || categoryTreeName.includes('Aggregate')
          ? []
          : [
              {
                title: "Average Price/KG",
                dataIndex: "averagePriceKG",
                key: "averagePriceKG",
                align: "right",
                render: (averagePriceKG) => {
                  if (initialBidDates && isNaN(averagePriceKG)) {
                    return "Not Quoted";
                  } else {
                    return averagePriceKG
                      ? `₹ ${averagePriceKG.toFixed(2)} / KG`
                      : `₹ 0`;
                  }
                },
              },
              // {
              //   title: "Average Price/Bag",
              //   dataIndex: "averagePriceBag",
              //   key: "averagePriceBag",
              //   align: "right",
              //   render: (averagePriceBag) => {
              //     if (initialBidDates && isNaN(averagePriceBag)) {
              //       return "Not Quoted";
              //     } else {
              //       return averagePriceBag
              //         ? `₹ ${averagePriceBag.toFixed(2)} / Bag`
              //         : `₹ 0`;
              //     }
              //   },
              // },
            ]),
      ],
    },
  ];

  const columns4Revised = [
    {
      title: "R1 - Revised BID (without GST)",
      children: [
        {
          title: "Material Type",
          dataIndex: "material_type_name",
          key: "material_type_name",
          width: 130,
        },
        ...(!categoryTreeName.includes("Earthing")
          ? [
        {
          title: "Average Price/MT",
          dataIndex: "averagePriceMT",
          key: "averagePriceMT",
          align: "right",
          render: (averagePriceMT) => {
            if (revisedBidDates && isNaN(averagePriceMT)) {
              return "Not Quoted";
            } else {
              return averagePriceMT
                ? `₹ ${averagePriceMT.toFixed(2)} / MT`
                : `₹ 0`;
            }
          },
        },
        {
                title: "Average Price/Bag",
                dataIndex: "averagePriceBag",
                key: "averagePriceBag",
                align: "right",
                render: (averagePriceBag) => {
                  if (revisedBidDates && isNaN(averagePriceBag)) {
                    return "Not Quoted";
                  } else {
                    return averagePriceBag
                      ? `₹ ${averagePriceBag.toFixed(2)} / Bag`
                      : `₹ 0`;
                  }
                },
              },
                 ]
          : []),
        ...(categoryTreeName.includes("Sand") || categoryTreeName.includes("Aggregate") &&
        !categoryTreeName.includes("Earthing")
          ? [
              {
                title: "Average Price/Cum.",
                dataIndex: "averagePriceCum",
                key: "averagePriceCum",
                align: "right",
                render: (averagePriceCum) => {
                  if (initialBidDates && isNaN(averagePriceCum)) {
                    return "Not Quoted";
                  } else {
                    return averagePriceCum
                      ? `₹ ${averagePriceCum.toFixed(2)} / Cum`
                      : `₹ 0`;
                  }
                },
              },
            ]
          : []),
          ...(categoryTreeName.includes("Earthing")
          ? [
              {
                title: "Average Price/Meter",
                dataIndex: "averagePriceMeter",
                key: "averagePriceMeter",
                align: "right",
                render: (value) =>
                  revisedBidDates && isNaN(value)
                    ? "Not Quoted"
                    : `₹ ${(value || 0).toFixed(2)} / Meter`,
              },
            ]
          : []),
        ...(categoryTreeName.includes("Sand") || categoryTreeName.includes("Aggregate")
          ? []
          : [
              {
                title: "Average Price/KG",
                dataIndex: "averagePriceKG",
                key: "averagePriceKG",
                align: "right",
                render: (averagePriceKG) => {
                  if (revisedBidDates && isNaN(averagePriceKG)) {
                    return "Not Quoted";
                  } else {
                    return averagePriceKG
                      ? `₹ ${averagePriceKG.toFixed(2)} / KG`
                      : `₹ 0`;
                  }
                },
              },
              // {
              //   title: "Average Price/Bag",
              //   dataIndex: "averagePriceBag",
              //   key: "averagePriceBag",
              //   align: "right",
              //   render: (averagePriceBag) => {
              //     if (revisedBidDates && isNaN(averagePriceBag)) {
              //       return "Not Quoted";
              //     } else {
              //       return averagePriceBag
              //         ? `₹ ${averagePriceBag.toFixed(2)} / Bag`
              //         : `₹ 0`;
              //     }
              //   },
              // },
            ]),
      ],
    },
  ];

  const columns4Final = [
    {
      title: "R - Final BID (without GST)",
      children: [
        {
          title: "Material Type",
          dataIndex: "material_type_name",
          key: "material_type_name",
          width: 130,
        },
        ...(!categoryTreeName.includes("Earthing")
          ? [ 
        {
          title: "Average Price/MT",
          dataIndex: "averagePriceMT",
          key: "averagePriceMT",
          align: "right",
          render: (averagePriceMT) => {
            if (finalBidDates && isNaN(averagePriceMT)) {
              return "Not Quoted";
            } else {
              return averagePriceMT
                ? `₹ ${averagePriceMT.toFixed(2)} / MT`
                : `₹ 0`;
            }
          },
        },
        {
                title: "Average Price/Bag",
                dataIndex: "averagePriceBag",
                key: "averagePriceBag",
                align: "right",
                render: (averagePriceBag) => {
                  if (finalBidDates && isNaN(averagePriceBag)) {
                    return "Not Quoted";
                  } else {
                    return averagePriceBag
                      ? `₹ ${averagePriceBag.toFixed(2)} / Bag`
                      : `₹ 0`;
                  }
                },
              },
                            ]
          : []),
        ...(categoryTreeName.includes("Sand") || categoryTreeName.includes("Aggregate") &&
        !categoryTreeName.includes("Earthing")
          ? [
              {
                title: "Average Price/Cum.",
                dataIndex: "averagePriceCum",
                key: "averagePriceCum",
                align: "right",
                render: (averagePriceCum) => {
                  if (revisedBidDates && isNaN(averagePriceCum)) {
                    return "Not Quoted";
                  } else {
                    return averagePriceCum
                      ? `₹ ${averagePriceCum.toFixed(2)} / Cum`
                      : `₹ 0`;
                  }
                },
              },
            ]
          : []),
                ...(categoryTreeName.includes("Earthing")
          ? [
              {
                title: "Average Price/Meter",
                dataIndex: "averagePriceMeter",
                key: "averagePriceMeter",
                align: "right",
                render: (value) =>
                  finalBidDates && isNaN(value)
                    ? "Not Quoted"
                    : `₹ ${(value || 0).toFixed(2)} / Meter`,
              },
            ]
          : []),
        ...(categoryTreeName.includes("Sand") || categoryTreeName.includes("Aggregate")
          ? []
          : [
              {
                title: "Average Price/KG",
                dataIndex: "averagePriceKG",
                key: "averagePriceKG",
                align: "right",
                render: (averagePriceKG) => {
                  if (finalBidDates && isNaN(averagePriceKG)) {
                    return "Not Quoted";
                  } else {
                    return averagePriceKG
                      ? `₹ ${averagePriceKG.toFixed(2)} / KG`
                      : `₹ 0`;
                  }
                },
              },
              // {
              //   title: "Average Price/Bag",
              //   dataIndex: "averagePriceBag",
              //   key: "averagePriceBag",
              //   align: "right",
              //   render: (averagePriceBag) => {
              //     if (finalBidDates && isNaN(averagePriceBag)) {
              //       return "Not Quoted";
              //     } else {
              //       return averagePriceBag
              //         ? `₹ ${averagePriceBag.toFixed(2)} / Bag`
              //         : `₹ 0`;
              //     }
              //   },
              // },
            ]),
      ],
    },
  ];

  const handleCheckboxChange = (e) => {
    const value = e.target.checked;
    setState((prevState) => ({
      ...prevState,
      is_final_bid_price: value,
    }));
  };

  const resetUnitRateWithGst = (item) => {
    item.bid_rfq_site_details.forEach((site) => {
      site.bid_rfq_material_details.forEach((material) => {
        material.unit_rate_with_gst = null;
      });
    });
    return item;
  };
  const handleBidSubmission = () => {
    if (state.is_final_bid_price) {
      handleSubmit();
    } else {
      handleSubmit();
      resetGSTValues();
      setCurrentStep(currentStep + 1);
    }
  };

  const handleSubmit = async () => {
    const currentDate = (() => {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear();
      return `${dd}-${mm}-${yyyy}`;
    })();

    const updatedTableData = tableData.map((item) => {
      if (!item.isSubtotal && item.material_type_name) {
        return {
          ...item,
          initial_bid_price_date: currentDate,
          revised_bid_price_date: currentDate,
          final_bid_price_date: currentDate,
        };
      }
      return item;
    });

    setTableData(updatedTableData);
    const uniqueEntries = new Map();
    const payload = {
      vendor: VendorId,
      bid_rfq_city_wise_detail: Array.from(
        tableData
          .reduce((cities, entry) => {
            if (!entry.siteId || entry.isSubtotal) return cities;

            const key = `${entry.siteId}_${entry.material_type}`;
            if (!uniqueEntries.has(key)) {
              uniqueEntries.set(key, true);
              if (!cities.has(entry.city_name)) {
                cities.set(entry.city_name, []);
              }
              cities.get(entry.city_name).push({
                site_id: entry.siteId,
                site_name: entry.site_name,
                site_wise_uom: entry.material_wise_uom,
                bid_rfq_material_details: [
                  {
                    material_type: entry.material_type,
                    initial_bid_price_unit_rate:
                      entry.initial_bid_price_unit_rate,
                    initial_bid_price_date: entry.initial_bid_price_date,
                    initial_bid_price_unit_rate_of_freight:
                      entry.initial_bid_price_unit_rate_of_freight,
                    revised_bid_price_unit_rate:
                      entry.revised_bid_price_unit_rate,
                    revised_bid_price_date: entry.revised_bid_price_date,
                    revised_bid_price_unit_rate_of_freight:
                      entry.initial_bid_price_unit_rate_of_freight,
                    final_bid_price_unit_rate:
                      entry.initial_bid_price_unit_rate,
                    final_bid_price_unit_rate_of_freight:
                      entry.initial_bid_price_unit_rate_of_freight,
                    final_bid_price_date: entry.final_bid_price_date,
                  },
                ],
              });
            }
            return cities;
          }, new Map())
          .values()
      ),
    };

    try {
      setLoading(true);
      let response;
      response = await patchRequest(
        `bid-rfq/${vendorBidId}/create-bid-rfq22/`,
        payload
      );

      if (response.data.success) {
        setLoading(false);

        let responseData = await getRequest(
          `bid-rfq/${vendorBidId}/get-bid-rfq-city-wise/?vendor_id=${VendorId}22`
        );

        if (currentStep === 0) {
          SuccessNotificationMsg(t("bidding_of_R0"));
        } else if (currentStep === 1) {
          SuccessNotificationMsg(t("bidding_of_R1"));
        } else {
          SuccessNotificationMsg(t("bidding_of_R"));
        }

        const newState2 = {
          vendor: VendorId,
          bid_rfq_vendor_detail:
            responseData.data.data[0].rfq_site_wise_vendor.map((site) => ({
              rfq_material_type_name: site.rfq_material_type_name,
              rfq_material_type: site.rfq_material_type_id,
              bid_rfq_detail: site.bid_rfq_detail.map((detail) => ({
                id: detail.bid_rfq_id,
                rfq_vendor_detail: detail.rfq_vendor_detail_id,
                purchase_requisition_site_id:
                  detail.purchase_requisition_site_id,
                purchase_requisition_site_name:
                  detail.purchase_requisition_site_name,
                site_wise_total_quantity: detail.site_wise_total_quantity,
                initial_bid_price_unit_rate: detail.initial_bid_price_unit_rate,
                initial_bid_price_unit_rate_of_freight:
                  detail.initial_bid_price_unit_rate_of_freight,
                initial_bid_price_total_unit_rate:
                  detail.initial_bid_price_total_unit_rate,
                initial_bid_price_date: currentDate,
                revised_bid_price_unit_rate: detail.revised_bid_price_unit_rate,
                revised_bid_price_unit_rate_of_freight:
                  detail.revised_bid_price_unit_rate_of_freight,
                revised_bid_price_total_unit_rate:
                  detail.revised_bid_price_total_unit_rate,
                final_bid_price_unit_rate: detail.final_bid_price_unit_rate,
                final_bid_price_unit_rate_of_freight:
                  detail.final_bid_price_unit_rate_of_freight,
                final_bid_price_total_unit_rate:
                  detail.final_bid_price_total_unit_rate,
              })),
            })),
        };

        setNewState2(newState2);
        setTableData(newState2);
        SuccessNotificationMsg(t("bidding_of_R0"));
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const dataSource = {
    isFinalBidPrice: false,
    company: null,
    rfqNumber: null,
    currency: null,
    priceBasis: null,
    freight: null,
    unloading: null,
    transportInsurance: null,
    openOrder: false,
    amountCap: null,
    timelineCap: null,
    deliveryDate: null,
    deliveryStartDate: null,
    deliveryEndDate: null,
    rfqDueDate: null,
    bidRfqCityWiseDetail: [
      {
        cityName: null,
        cityId: null,
        bidRfqSiteDetails: [
          {
            siteId: null,
            siteName: null,
            siteWiseUom: null,
            totalUnitRateOfCement: "",
            rfqVendorDetail: "",
            bidRfqMaterialDetails: [
              {
                materialTypeName: null,
                rfqMaterialDetail: null,
                gstRate: null,
                materialType: null,
                materialTotalQuantity: null,
                materialWiseUom: null,
                initialBidPriceUnitRate: null,
                initialBidPriceUnitRateOfFreight: null,
                revisedBidPriceUnitRate: null,
                revisedBidPriceUnitRateOfFreight: null,
                finalBidPriceUnitRate: null,
                finalBidPriceUnitRateOfFreight: null,
                unitRateWithGst: null,
                amountWithoutGst: null,
                amountWithGst: null,
                lqpForThisClient: 5678,
                lqpForThisAnyClient: 2290,
              },
            ],
          },
        ],
      },
    ],
  };

  const transformedData = {
    companyName: rfqDetails.company,
    rfqnumber: rfqDetails.rfq_number,
    rfqcurrency: rfqDetails.currency_name,
    rfqpricebasis: rfqDetails.price_basis,
    rfqfreight: rfqDetails.freight,
    rfqunloading: rfqDetails.unloading,
    rfqtransportInsurance: rfqDetails.transport_insurance,
    rfqduedate: rfqDetails.rfq_due_date,
    rfqopendeliverydate: rfqDetails.delivery_date,
    rfqamountcap: rfqDetails.amount_cap || "N/A",
    rfqtimelinecap: rfqDetails.open_order ? "Timeline Cap Data" : "N/A",
    rfqdeliverystartdate: rfqDetails.delivery_start_date || "N/A",
    rfqdeliveryenddate: rfqDetails.delivery_end_date || "N/A",
    open_order: rfqDetails.open_order,
  };

  const columns1 = [
    {
      title: "Company Name",
      dataIndex: "companyName",
      key: "companyName",
    },
    {
      title: "RFQ Number",
      dataIndex: "rfqnumber",
      key: "rfqnumber",
    },
    {
      title: "Currency",
      dataIndex: "rfqcurrency",
      key: "rfqcurrency",
    },
    {
      title: "Price Basis",
      dataIndex: "rfqpricebasis",
      key: "rfqpricebasis",
    },
    {
      title: "Freight",
      dataIndex: "rfqfreight",
      key: "rfqfreight",
    },
    {
      title: "Unloading",
      dataIndex: "rfqunloading",
      key: "rfqunloading",
    },
    {
      title: "Transport Insurance",
      dataIndex: "rfqtransportInsurance",
      key: "rfqtransportInsurance",
    },
    {
      title: "RFQ Due Date",
      dataIndex: "rfqduedate",
      key: "rfqduedate",
    },
    !rfqData.open_order && {
      title: "Delivery Date",
      dataIndex: "rfqopendeliverydate",
      key: "rfqopendeliverydate",
      render: (text, record) =>
        record.open_order ? "N/A" : record.rfqopendeliverydate,
    },
    rfqData.open_order && {
      title: "Amount Cap",
      dataIndex: "rfqamountcap",
      key: "rfqamountcap",
      render: (text, record) => (record.open_order ? text : "N/A"),
    },
    rfqData.open_order && {
      title: "Delivery Start Date",
      dataIndex: "rfqdeliverystartdate",
      key: "rfqdeliverystartdate",
      render: (text, record) => (record.open_order ? text : "N/A"),
    },
    rfqData.open_order && {
      title: "Delivery End Date",
      dataIndex: "rfqdeliveryenddate",
      key: "rfqdeliveryenddate",
      render: (text, record) => (record.open_order ? text : "N/A"),
    },
  ].filter(Boolean);

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename" style={{ whiteSpace: "nowrap" }}>
            <h3>View - BID RFQ Vendor</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/rfq-vendor-request-for-quotation/history/1">
                  {t("RFQ History - Vendor")}
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>View - BID RFQ Vendor</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              justifyContent: "flex-end",
            }}
          >
            <div className="dayfilter" style={{ color: "#094E8F" }}>
              <strong>Winning Ratio:</strong>
              <span
                className="rfq-number new"
                style={{ margin: "0", padding: "0" }}
              >
                {winningArray.map((item) => (
                  <Tooltip
                    key={item.key}
                    color="#094E8F"
                    placement="top"
                    title={`${item.value}%`}
                  >
                    <span
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      {item.key}
                    </span>
                  </Tooltip>
                ))}
              </span>
            </div>
            <div className="dayfilter" style={{ color: "#094E8F" }}>
              <strong>Last 5 BID Result :</strong>
              <div
                className="rfq-number new"
                style={{ margin: "0", padding: "0" }}
              >
                {lastFiveBid?.reverse().map((bid, index) => {
                  let res = "";

                  if (bid === "Loose") {
                    res = "L";
                  } else if (bid === "N/A") {
                    res = "N/A";
                  } else {
                    res = "W";
                  }
                  if (index === 0) {
                    return (
                      <Tooltip
                        color="#094E8F"
                        placement="top"
                        title={"Latest"}
                        key={index}
                      >
                        <span>{res || ""}</span>
                      </Tooltip>
                    );
                  } else if (lastFiveBid.length - 1 === index) {
                    return (
                      <Tooltip
                        color="#094E8F"
                        placement="top"
                        title={"Earliest"}
                        key={index}
                      >
                        <span>{res || ""}</span>
                      </Tooltip>
                    );
                  } else {
                    return <span key={index}>{res || ""}</span>;
                  }
                })}
              </div>
            </div>
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              <Col className="TextFeild gutter-row">
                <Space>
                  <span className="box">
                    <label className="cp" style={{ color: "red" }}>
                      <strong>Assign RFQ : </strong>
                    </label>

                    <AssignRFQVendor
                      assignToBuyer={rfqDetails.rfq_vendor_assign_sales_manager}
                      assignBuyer={assignBuyer}
                      rfqDetails={rfqDetails}
                      disableAssign={disableAssign}
                    />
                  </span>
                  {isRfqDueDateValid() &&
                    rfqAssignedOrNot !== null &&
                    bidRfqByVendor === false &&
                    !isFinalBidPrice1 && (
                      <Link
                        to={{
                          pathname:
                            "/rfq-vendor-request-for-quotation-city-wise/bid-rfq/" +
                            btoa(vendorBidId),
                        }}
                      >
                        <Tooltip
                          color="#094E8F"
                          title={"Submit BID"}
                          placement="left"
                        >
                          <ButtonField
                            type="primary"
                            className="SaveGradiantBtn"
                            htmlType="button"
                            label={t("BID")}
                          />
                        </Tooltip>
                      </Link>
                    )}
                </Space>
              </Col>
              <ButtonField
                type="primary"
                className="CancelGradiantBtn"
                htmlType="button"
                label={t("Back")}
                onClick={() =>
                  navigate("/rfq-vendor-request-for-quotation/history/1")
                }
              />
            </div>
          </div>
        </div>
      </div>
      <Content className="stepscontentwrap">
        <div className="stepsContent">
          <section className="grid-sec ">
            <div className="PR-body" style={{ padding: "0" }}>
              <div
                style={{
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "#fff",
                  marginBottom: "16px",
                }}
              >
                <Collapse
                  defaultActiveKey={[0]}
                  key={0}
                  className="custom-collapse-table"
                >
                  <Panel header={"RFQ Details"} key={0}>
                    <div style={{ marginTop: "10px" }}>
                      <Table
                        className="custom-head"
                        columns={columns1}
                        dataSource={[transformedData]}
                        pagination={false}
                      />
                    </div>
                  </Panel>
                </Collapse>
              </div>

              <div>
                <Form autoComplete="off" ref={formRef} onFinish={handleSubmit}>
                  <Spin spinning={apiLoading}>
                    <Table
                      columns={columns}
                      dataSource={tableData}
                      pagination={false}
                      scroll={{
                        x: 1200,
                      }}
                      bordered
                      sticky
                    />
                  </Spin>
                  <Row gutter={16} className="footerTablesContainer">
                    <Col
                      xs={24}
                      md={12}
                      className="footerTable3"
                      style={{ paddingTop: "16px" }}
                    >
                      {finalDate && (
                        <Table
                          columns={columns4Final}
                          dataSource={summaryTableDataFinal}
                          pagination={false}
                          bordered
                          scroll={{
                            x: 500,
                          }}
                        />
                      )}
                      {revisedDate && !hideR1 && (
                        <Table
                          columns={columns4Revised}
                          dataSource={summaryTableDataRevised}
                          pagination={false}
                          bordered
                          scroll={{
                            x: 500,
                          }}
                        />
                      )}
                      {!hideR0 && (
                        <Table
                          columns={columns4}
                          dataSource={summaryTableData2}
                          pagination={false}
                          bordered
                          scroll={{
                            x: 500,
                          }}
                        />
                      )}
                    </Col>
                    <Col
                      xs={24}
                      md={12}
                      className="footerTable4"
                      style={{ paddingTop: "16px" }}
                    >
                      <Table
                        columns={columns3}
                        dataSource={summaryTableData}
                        pagination={false}
                        bordered
                        scroll={{
                          // x: 1500,
                          x: 600,
                        }}
                      />
                    </Col>
                  </Row>
                  <div className="FormFooter">
                    {revisedDate && (
                      <>
                        <Checkbox
                          checked={hideR0}
                          onChange={handleHideR0Change}
                        >
                          Hide Initial BID Price - R0
                        </Checkbox>
                      </>
                    )}
                    {finalDate && !AsFinalBidPrice && (
                      <>
                        <Checkbox
                          checked={hideR1}
                          onChange={handleHideR1Change}
                        >
                          Hide BID Price - R1
                        </Checkbox>
                      </>
                    )}
                  </div>
                </Form>
              </div>
            </div>
          </section>
        </div>
        <div
          className="FormFooter bidftr"
          style={{ padding: "16px  ", margin: "0" }}
        >
          <ButtonField
            type="primary"
            className="CancelGradiantBtn"
            htmlType="button"
            label={t("Back")}
            onClick={() =>
              navigate("/rfq-vendor-request-for-quotation/history/1")
            }
          />
        </div>
      </Content>
    </>
  );
};

export default ViewNewVendorBidRFQ;
